(() => {
  const initQuote = (scope) => {
    const roots = scope.querySelectorAll('[data-apq-app]');

    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const section = root.closest('.apq');
      const form = root.closest('form');
      const sectionId = section.dataset.sectionId;
      const storageKey = `austpek-rfq-${sectionId}`;
      const visualizerStorageKey = 'austpek-rfq-visualizer-products';
      const visualizerMaxProducts = 4;
      const routesRoot = window.Shopify?.routes?.root || '/';
      const moneyFormat = section.dataset.moneyFormat || window.theme?.moneyFormat || ['$', '{', '{amount}}'].join('');
      const state = {
        route: '',
        panel: '',
        cart: null,
        includedKeys: new Set(),
        reviewedSignature: '',
        searchTimer: null,
        searchController: null,
        hasInclusionSelection: false,
        isSubmitting: false,
        isUpdatingCart: false,
        isAddingProduct: false,
        productModalOpen: false,
        editingLineKey: null,
        editingItem: null,
        restoreSearchFocus: false,
        fromVisualizerList: false,
        modalCache: new Map(),
        modalToken: 0,
        restoringConfig: false,
        // Set when "Edit configuration" could not put the saved options back: saving then would
        // overwrite the line with whatever partial editor state is showing.
        restoreBlocked: false,
        lastModalOpen: null,
        globoSucceeded: false,
        globoEmail: '',
        globoSubmitAttempted: false,
        summaryExpanded: false,
        visualizerHandles: [],
        visualizerProducts: {},
        visualizerHydrating: false,
        visualizerNeedsRender: false,
      };

      const labels = {
        decrease: section.dataset.labelDecrease || 'Decrease quantity',
        increase: section.dataset.labelIncrease || 'Increase quantity',
        quantity: section.dataset.labelQuantity || 'Quantity',
        remove: section.dataset.labelRemove || 'Remove',
        add: section.dataset.labelAdd || 'Add to quote',
        adding: section.dataset.labelAdding || 'Adding…',
        added: section.dataset.labelAdded || 'Added to your quote.',
        saveConfiguration: section.dataset.labelSaveConfiguration || 'Save configuration',
        updated: section.dataset.labelUpdated || 'Configuration updated.',
        editConfiguration: section.dataset.labelEditConfiguration || 'Edit configuration',
        restoringSaved: section.dataset.labelRestoringSaved || 'Loading your saved options…',
        restoringOptions: section.dataset.labelRestoringOptions || 'Loading options…',
        summaryMore: section.dataset.labelSummaryMore || '+ __COUNT__ more',
        summaryLess: section.dataset.labelSummaryLess || 'Show less',
        visualizerLoading: section.dataset.labelVisualizerLoading || 'Loading products from your bathroom…',
        visualizerUnavailable: section.dataset.labelVisualizerUnavailable || 'This product could not be loaded.',
        visualizerStatus: section.dataset.labelVisualizerStatus || '__COUNT__ products from your bathroom',
      };

      const query = (selector, scope = root) => scope.querySelector(selector);
      const queryAll = (selector, scope = root) => Array.from(scope.querySelectorAll(selector));
      const startScreen = query('[data-screen="start"]');
      const flowScreen = query('[data-screen="flow"]');
      const successScreen = query('[data-screen="success"]');
      const notice = query('[data-notice]');
      const summaryCount = query('[data-summary-count]');
      const summaryContent = query('[data-summary-content]');
      const summaryEditWrap = query('[data-summary-edit-wrap]');
      const quoteBodyField = query('[data-quote-body]');
      const routeField = query('[data-route-field]');
      const productCountField = query('[data-product-count-field]');
      const referenceField = query('[data-quote-reference]');
      const contactNameField = query('[data-contact-name]');
      const productsNeededField = query('[data-products-needed-field]');
      const productModal = section.querySelector('[data-apq-product-modal]');
      const productModalInner = section.querySelector('[data-apq-product-modal-inner]');
      const productModalOpenButton = section.querySelector('[data-apq-open-modal]');
      const productModalNotice = section.querySelector('[data-apq-modal-notice]');
      const productModalRestoring = section.querySelector('[data-apq-modal-restoring]');
      const productModalRestoringText = section.querySelector('[data-apq-modal-restoring-text]');
      const globoHost = section.querySelector('[data-apq-globo-host]');
      const globoSlot = query('[data-globo-slot]');
      const globoLoading = section.querySelector('[data-globo-loading]');
      const isUploadRoute = (route = state.route) => route === 'build' || route === 'upload';
      const routeLabel = (route = state.route) => {
        if (route === 'cart') return 'Use my cart';
        if (route === 'add') return 'Add products';
        return 'Upload your products list';
      };

      const showModalNotice = (message, action = null) => {
        if (!productModalNotice) return;
        productModalNotice.replaceChildren();
        if (message) {
          const text = document.createElement('span');
          text.textContent = message;
          productModalNotice.append(text);
          if (action) {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'apq__text-button apq__modal-notice-action';
            button.textContent = action.label;
            button.addEventListener('click', action.onClick, { once: true });
            productModalNotice.append(button);
          }
        }
        productModalNotice.hidden = !message;
      };

      const hideModalNotice = () => showModalNotice('');

      const showRestoringStatus = (message) => {
        if (!productModalRestoring) return;
        if (productModalRestoringText) productModalRestoringText.textContent = message || '';
        productModalRestoring.hidden = !message;
      };

      const hideRestoringStatus = () => showRestoringStatus('');

      const globoForm = () => globoHost?.querySelector('.globo-form-app form, .globo-formbuilder form, form.g-container');

      const globoFileInput = () => globoHost?.querySelector('input[type="file"]');

      const globoFileNames = () => {
        const names = [];
        const input = globoFileInput();
        if (input?.files) {
          for (const file of input.files) {
            if (file?.name) names.push(file.name);
          }
        }
        globoHost?.querySelectorAll(
          '.gfb__dropzone--filename, .gfb-file-name, .gfb__file-name, [class*="filename"], [class*="file-name"]'
        ).forEach((element) => {
          const text = element.textContent.replace(/\s+/g, ' ').trim();
          if (text && !names.includes(text)) names.push(text);
        });
        return names;
      };

      const globoEmailValue = () => {
        if (!globoHost) return '';
        const isCustomerField = (field) => {
          const name = (field.getAttribute('name') || '').toLowerCase();
          return name.startsWith('customer[') || name === 'customer[email]';
        };
        const fromType = globoHost.querySelector(
          '.globo-form-control[data-type="email"] input, .globo-form-control[data-type="email"] textarea'
        );
        if (fromType?.value?.trim() && !isCustomerField(fromType)) return fromType.value.trim();
        const labeled = Array.from(
          globoHost.querySelectorAll('.globo-form-control input, .globo-form-control textarea')
        ).find((field) => {
          if (isCustomerField(field)) return false;
          const control = field.closest('.globo-form-control');
          const label = control?.querySelector('[data-label]')?.getAttribute('data-label') || '';
          const name = field.getAttribute('name') || '';
          return /email/i.test(`${label} ${name}`);
        });
        return labeled?.value?.trim() || '';
      };

      const SUCCESS_STORE_KEY = 'austpek-rfq-success';

      const readQuoteSuccessDetails = () => {
        try {
          const parsed = JSON.parse(sessionStorage.getItem(SUCCESS_STORE_KEY) || 'null');
          if (!parsed || typeof parsed !== 'object') return null;
          return parsed;
        } catch (error) {
          return null;
        }
      };

      const persistQuoteSuccessDetails = (details = {}) => {
        const current = readQuoteSuccessDetails() || {};
        const next = {
          email: String(details.email || current.email || '').trim(),
          reference: String(details.reference || current.reference || '').trim(),
        };
        if (!next.email && !next.reference) return;
        try {
          sessionStorage.setItem(SUCCESS_STORE_KEY, JSON.stringify(next));
        } catch (error) {
          // Same-page success can still use in-memory state.
        }
      };

      const setNativeValue = (field, value) => {
        if (!field) return;
        const proto = field.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
        const setter = Object.getOwnPropertyDescriptor(proto, 'value')?.set;
        if (setter) setter.call(field, value);
        else field.value = value;
        field.setAttribute('value', value);
        field.dispatchEvent(new InputEvent('input', { bubbles: true, composed: true }));
        field.dispatchEvent(new Event('change', { bubbles: true }));
      };

      const globoFieldKey = (node) =>
        [
          node.getAttribute('data-label'),
          node.getAttribute('data-element-id'),
          node.getAttribute('name'),
          node.getAttribute('id'),
          node.getAttribute('placeholder'),
          node.textContent,
        ]
          .join(' ')
          .toLowerCase()
          .replace(/[\s_-]+/g, '');

      const isAqReferenceKey = (value) => String(value || '').toLowerCase().replace(/[\s_-]+/g, '').includes('aqreference');

      const globoReferenceNameFromLabels = () => {
        const raw = globoHost?.querySelector('input[name="_keyLabel"]')?.value;
        if (!raw) return '';
        try {
          const labels = JSON.parse(raw);
          return (
            Object.keys(labels).find((name) => isAqReferenceKey(name) || isAqReferenceKey(labels[name])) || ''
          );
        } catch (error) {
          return '';
        }
      };

      const globoReferenceInput = () => {
        if (!globoHost) return null;
        const named = globoReferenceNameFromLabels();
        if (named) {
          const match = globoHost.querySelector(
            `[name="${CSS.escape(named)}"], [name="${CSS.escape(named)}[]"]`
          );
          if (match) return match;
        }
        const nodes = globoHost.querySelectorAll(
          '.globo-form-control, .globo-form-control input, .globo-form-control textarea, [data-label], input, textarea'
        );
        for (const node of nodes) {
          if (!isAqReferenceKey(globoFieldKey(node))) continue;
          if (node.matches('input, textarea')) return node;
          const field = node.querySelector('input, textarea');
          if (field) return field;
        }
        return globoHost.querySelector('[data-apq-globo-reference]');
      };

      const ensureGloboReferenceInput = () => {
        let field = globoReferenceInput();
        if (field) return field;
        const formEl = globoForm();
        if (!formEl) return null;
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = globoReferenceNameFromLabels() || 'AQ_REFERENCE';
        field.setAttribute('data-apq-globo-reference', 'true');
        formEl.appendChild(field);
        return field;
      };

      const syncGloboReferenceField = (reference) => {
        const value = reference || createReference();
        persistQuoteSuccessDetails({ reference: value, email: readGloboEmail() || globoEmailValue() });
        if (referenceField) referenceField.value = value;
        const field = ensureGloboReferenceInput();
        if (field) setNativeValue(field, value);
        return value;
      };

      const injectReferenceIntoBody = (body) => {
        const reference = createReference();
        persistQuoteSuccessDetails({ reference, email: readGloboEmail() || globoEmailValue() });
        const field = ensureGloboReferenceInput();
        const names = Array.from(
          new Set([field?.getAttribute('name'), globoReferenceNameFromLabels(), 'AQ_REFERENCE'].filter(Boolean))
        );
        if (field) setNativeValue(field, reference);
        if (!names.length) return body;
        if (body instanceof FormData) {
          names.forEach((name) => body.set(name.replace(/\[\]$/, ''), reference));
          return body;
        }
        if (body instanceof URLSearchParams) {
          names.forEach((name) => body.set(name.replace(/\[\]$/, ''), reference));
          return body;
        }
        if (typeof body === 'string') {
          try {
            const json = JSON.parse(body);
            const write = (obj) => {
              if (!obj || typeof obj !== 'object') return;
              names.forEach((name) => {
                const key = name.replace(/\[\]$/, '');
                obj[key] = reference;
                obj[name] = reference;
              });
              ['fields', 'data', 'values', 'payload', 'form'].forEach((child) => {
                if (obj[child] && typeof obj[child] === 'object' && !Array.isArray(obj[child])) write(obj[child]);
              });
            };
            write(json);
            return JSON.stringify(json);
          } catch (error) {
            if (body.includes('=')) {
              const params = new URLSearchParams(body);
              names.forEach((name) => params.set(name.replace(/\[\]$/, ''), reference));
              return params.toString();
            }
          }
        }
        return body;
      };

      const persistGloboEmail = (email) => {
        const value = String(email || '').trim();
        if (value) state.globoEmail = value;
        if (!value) return;
        persistQuoteSuccessDetails({ email: value });
        try {
          sessionStorage.setItem(`${storageKey}-globo-email`, value);
        } catch (error) {
          // Email still lives on state for same-page success handling.
        }
      };

      const readGloboEmail = () => {
        if (state.globoEmail) return state.globoEmail;
        try {
          return sessionStorage.getItem(`${storageKey}-globo-email`) || '';
        } catch (error) {
          return '';
        }
      };

      const markGloboSubmitAttempted = (email) => {
        state.globoSubmitAttempted = true;
        persistGloboEmail(email || globoEmailValue());
        syncGloboReferenceField();
      };

      const urlHasQuoteSent = () => {
        try {
          const params = new URLSearchParams(window.location.search);
          return ['quote_sent', 'submitted'].some((name) => {
            if (!params.has(name)) return false;
            const value = params.get(name).trim().toLowerCase();
            return value === '' || value === '1' || value === 'true' || value === 'upload' || value === 'success';
          });
        } catch (error) {
          return false;
        }
      };

      const cleanQuoteSentParam = () => {
        try {
          const cleanUrl = new URL(window.location.href);
          cleanUrl.searchParams.delete('quote_sent');
          cleanUrl.searchParams.delete('submitted');
          window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
        } catch (error) {
          // Keep the query param if history API is unavailable.
        }
      };

      const isGloboSendRequest = (url, method) => {
        const href = String(url || '').toLowerCase();
        const verb = String(method || 'GET').toUpperCase();
        if (verb !== 'POST' && verb !== 'PUT') return false;
        return href.includes('globosoftware') || href.includes('globo-form') || href.includes('globoform');
      };

      const placeGloboHost = () => {
        if (!globoHost) return;
        const active =
          isUploadRoute() && state.panel === 'build' && !query('[data-panel="build"]')?.hidden && successScreen.hidden;
        globoHost.classList.toggle('is-active', active);
        if (active) {
          globoHost.removeAttribute('aria-hidden');
          globoHost.removeAttribute('inert');
        } else {
          globoHost.setAttribute('aria-hidden', 'true');
          globoHost.setAttribute('inert', '');
          globoHost.style.top = '';
          globoHost.style.left = '';
          globoHost.style.width = '';
          globoHost.style.height = '';
          return;
        }
        if (!globoSlot) return;
        const slotRect = globoSlot.getBoundingClientRect();
        const sectionRect = section.getBoundingClientRect();
        globoHost.style.top = `${slotRect.top - sectionRect.top}px`;
        globoHost.style.left = `${slotRect.left - sectionRect.left}px`;
        globoHost.style.width = `${slotRect.width}px`;
        globoSlot.style.minHeight = `${Math.max(globoHost.offsetHeight, 420)}px`;
      };

      const syncUploadChrome = () => {
        const uploadActive = isUploadRoute() && !flowScreen.hidden;
        section.classList.toggle('is-upload-flow', uploadActive);
        const stepper = query('[data-stepper]');
        if (stepper) stepper.hidden = uploadActive;
        if (uploadActive) syncGloboReferenceField();
        placeGloboHost();
      };

      const enhanceGloboForm = () => {
        if (!globoHost) return false;
        const formEl = globoForm();
        const ready = Boolean(formEl || globoHost.querySelector('.globo-form-app, .gfb__dropzone, input[type="file"]'));
        if (!ready) return false;
        if (globoLoading) globoLoading.hidden = true;
        if (formEl && !formEl.id) formEl.id = `ApqGloboForm-${sectionId}`;
        if (formEl) {
          globoHost.querySelectorAll('input, textarea, select, button').forEach((field) => {
            field.setAttribute('form', formEl.id);
          });
        }
        if (isUploadRoute()) syncGloboReferenceField();
        placeGloboHost();
        return true;
      };

      const bindGloboHost = () => {
        if (!globoHost || globoHost.dataset.apqBound === 'true') return;
        globoHost.dataset.apqBound = 'true';
        globoHost.addEventListener(
          'submit',
          (event) => {
            if (!isUploadRoute()) return;
            markGloboSubmitAttempted(globoEmailValue());
          },
          true
        );
        globoHost.addEventListener('click', (event) => {
          if (!isUploadRoute()) return;
          const submitter = event.target.closest(
            'button[type="submit"], input[type="submit"], .wizard__submit, button.action.next.submit, .gfb__footer button'
          );
          if (!submitter) return;
          markGloboSubmitAttempted(globoEmailValue());
        });
        globoHost.addEventListener('change', () => {
          if (!isUploadRoute()) return;
          persistGloboEmail(globoEmailValue());
          updateSummary();
          saveDraft();
          placeGloboHost();
        });
        const observer = new MutationObserver(() => {
          enhanceGloboForm();
          if (isUploadRoute()) {
            updateSummary();
            placeGloboHost();
          }
        });
        observer.observe(globoHost, { childList: true, subtree: true, characterData: true });
        enhanceGloboForm();
        window.addEventListener('resize', placeGloboHost);
        window.addEventListener('pagehide', () => {
          if (!state.globoSubmitAttempted) return;
          persistQuoteSuccessDetails({
            email: readGloboEmail() || globoEmailValue(),
            reference: createReference(),
          });
        });
      };

      const createElement = (tag, className, text) => {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (text !== undefined) element.textContent = text;
        return element;
      };

      const isPresent = (value) => value !== null && value !== undefined && String(value).trim() !== '';

      const formatWithDelimiters = (cents, precision, thousands, decimal) => {
        const amountCents = Number(cents);
        const safeCents = Number.isFinite(amountCents) ? amountCents : 0;
        const value = (Math.abs(safeCents) / 100).toFixed(precision);
        const parts = value.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        const formatted = parts.length > 1 ? `${parts[0]}${decimal}${parts[1]}` : parts[0];
        return safeCents < 0 ? `-${formatted}` : formatted;
      };

      const money = (cents) => {
        const format = moneyFormat;
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          try {
            return window.Shopify.formatMoney(cents, format);
          } catch (error) {
            // Fall through to the local formatter.
          }
        }
        const tokenMatch = format.match(/\{\{\s*(\w+)\s*\}\}/);
        const token = tokenMatch ? tokenMatch[1] : 'amount';
        let value = '';
        switch (token) {
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0, ',', '.');
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'", '.');
            break;
          default:
            value = formatWithDelimiters(cents, 2, ',', '.');
        }
        return format.replace(/\{\{\s*\w+\s*\}\}/, value);
      };

      const formatBudget = (value) => {
        if (!isPresent(value)) return '';
        const number = Number(value);
        if (!Number.isFinite(number)) return String(value);
        return money(number * 100);
      };

      const publicProperties = (item) =>
        Object.entries(item.properties || {}).filter(([key, value]) => {
          return isPresent(value) && !String(key).startsWith('_');
        });

      const allProperties = (item) => Object.entries(item.properties || {}).filter(([, value]) => isPresent(value));

      const includedItems = () => {
        if (!state.cart?.items) return [];
        return state.cart.items;
      };

      const cartSignature = () => {
        if (!state.cart?.items) return '';
        return JSON.stringify(
          state.cart.items.map((item) => ({
            key: item.key,
            quantity: item.quantity,
            final_line_price: item.final_line_price,
            properties: item.properties || {},
          }))
        );
      };

      const showNotice = (message) => {
        notice.textContent = message;
        notice.hidden = !message;
        if (message) notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };

      const hideNotice = () => showNotice('');

      const getFormSnapshot = () => {
        const fields = queryAll('input[name], textarea[name], select[name]', form);
        const values = {};
        fields.forEach((field) => {
          if (field.type === 'hidden' || field.name === 'contact[body]') return;
          if (field.type === 'checkbox') {
            if (!values[field.name]) values[field.name] = [];
            if (field.checked) values[field.name].push(field.value);
            return;
          }
          if (field.type === 'radio') {
            if (field.checked) values[field.name] = field.value;
            return;
          }
          values[field.name] = field.value;
        });
        return values;
      };

      const saveDraft = () => {
        try {
          sessionStorage.setItem(
            storageKey,
            JSON.stringify({
              route: state.route,
              panel: state.panel,
              includedKeys: Array.from(state.includedKeys),
              reviewedSignature: state.reviewedSignature,
              values: getFormSnapshot(),
            })
          );
          if (state.route) sessionStorage.setItem('austpek-rfq-route', state.route);
          if (state.panel) sessionStorage.setItem('austpek-rfq-panel', state.panel);
        } catch (error) {
          return;
        }
      };

      const readDraft = () => {
        try {
          return JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        } catch (error) {
          return null;
        }
      };

      const restoreValues = (values = {}) => {
        Object.entries(values).forEach(([name, value]) => {
          const fields = queryAll(`[name="${CSS.escape(name)}"]`, form);
          fields.forEach((field) => {
            if (field.type === 'checkbox') {
              field.checked = Array.isArray(value) ? value.includes(field.value) : value === field.value;
            } else if (field.type === 'radio') {
              field.checked = field.value === value;
            } else {
              field.value = value || '';
            }
          });
        });

        const legacyProducts = values['contact[Products needed][]'];
        if (!values.package_product && legacyProducts) {
          const selected = Array.isArray(legacyProducts) ? legacyProducts : [legacyProducts];
          queryAll('[data-package-product]', form).forEach((field) => {
            field.checked = selected.includes(field.value);
          });
        }
      };

      const setStep = (step) => {
        queryAll('[data-step-indicator]').forEach((indicator) => {
          const number = Number(indicator.dataset.stepIndicator);
          indicator.classList.toggle('is-active', number === step);
          indicator.classList.toggle('is-complete', number < step);
        });
      };

      const panelStep = (panel) => {
        if (panel === 'project') return 2;
        if (panel === 'contact') return 3;
        return 1;
      };

      const syncUploadCartHandoff = async () => {
        const handoff = query('[data-upload-cart-handoff]');
        if (!handoff) return;
        try {
          const response = await fetch(`${routesRoot}cart.js`, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) return;
          const cart = await response.json();
          handoff.hidden = !(Number(cart.item_count) > 0);
        } catch (error) {
          // Keep the server-rendered visibility if the cart cannot be read.
        }
      };

      const showPanel = (panel, options = {}) => {
        if (isUploadRoute()) panel = 'build';
        state.panel = panel;
        startScreen.hidden = true;
        successScreen.hidden = true;
        flowScreen.hidden = false;
        queryAll('[data-panel]').forEach((element) => {
          element.hidden = element.dataset.panel !== panel;
        });
        setStep(panelStep(panel));
        summaryEditWrap.hidden = panel !== 'contact';
        const summaryProducts = query('[data-summary-edit-products]');
        if (summaryProducts) summaryProducts.textContent = 'Edit products';
        updateSummary();
        hideNotice();
        saveDraft();
        syncUploadChrome();
        if (panel === 'build') syncUploadCartHandoff();
        window.requestAnimationFrame(placeGloboHost);
        if (!options.noScroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      const showStart = () => {
        state.route = '';
        state.panel = '';
        flowScreen.hidden = true;
        successScreen.hidden = true;
        startScreen.hidden = false;
        hideNotice();
        query('[data-cart-switch-confirm]')?.setAttribute('hidden', '');
        saveDraft();
        syncUploadChrome();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      const updateStepOneLabel = () => {
        const label = query('[data-step-one-label]');
        label.textContent = isUploadRoute() ? 'Upload' : 'Products';
      };

      const syncRouteControls = () => {
        syncUploadChrome();
      };

      const markQuoteStarted = (route) => {
        try {
          sessionStorage.setItem('austpek-rfq-started', '1');
          if (route) sessionStorage.setItem('austpek-rfq-route', route);
        } catch (error) {
          // Session storage may be unavailable.
        }
        try {
          document.cookie = 'austpek-rfq-started=1;path=/;max-age=604800;SameSite=Lax';
        } catch (error) {
          // Cookie may be unavailable.
        }
        if (window.RQ && typeof window.RQ.markStarted === 'function') {
          window.RQ.markStarted(route);
        } else if (window.RQ && typeof window.RQ.syncTriggers === 'function') {
          window.RQ.syncTriggers();
        }
      };

      const wipeQuoteStorage = () => {
        const keys = [
          'austpek-rfq-quote',
          'austpek-rfq-started',
          'austpek-rfq-route',
          'austpek-rfq-panel',
          storageKey,
          `${storageKey}-reference`,
          `${storageKey}-globo-email`,
          visualizerStorageKey,
        ];
        for (const key of keys) {
          try {
            sessionStorage.removeItem(key);
          } catch (error) {
            // Ignore storage failures.
          }
          try {
            localStorage.removeItem(key);
          } catch (error) {
            // Ignore storage failures.
          }
        }
        try {
          document.cookie = 'austpek-rfq-started=;path=/;max-age=0;SameSite=Lax';
        } catch (error) {
          // Ignore cookie failures.
        }
      };

      const resetQuoteState = () => {
        state.route = '';
        state.panel = '';
        state.cart = null;
        state.includedKeys = new Set();
        state.reviewedSignature = '';
        state.hasInclusionSelection = false;
        state.isSubmitting = false;
        state.isUpdatingCart = false;
        state.isAddingProduct = false;
        state.visualizerHandles = [];
        state.visualizerProducts = {};
        state.visualizerHydrating = false;
        state.visualizerNeedsRender = false;
        const visualizerBlock = query('[data-visualizer-block]');
        if (visualizerBlock) visualizerBlock.hidden = true;
        if (typeof form.reset === 'function') form.reset();
      };

      const applyRqClear = () => {
        if (!window.RQ) return;
        if (typeof window.RQ.clear === 'function') window.RQ.clear();
        else if (typeof window.RQ.clearStarted === 'function') window.RQ.clearStarted();
        if (typeof window.RQ.close === 'function') window.RQ.close();
        if (typeof window.RQ.syncTriggers === 'function') window.RQ.syncTriggers();
      };

      const resetQuoteFlow = () => {
        wipeQuoteStorage();
        resetQuoteState();
        if (window.RQ) {
          applyRqClear();
          return;
        }
        document.addEventListener('rq:ready', applyRqClear, { once: true });
      };

      const startRoute = async (route, options = {}) => {
        query('[data-cart-switch-confirm]')?.setAttribute('hidden', '');
        state.route = route;
        markQuoteStarted(route);
        updateStepOneLabel();
        routeField.value = routeLabel(route);
        syncRouteControls();
        let quoteLoaded = true;
        if (route === 'cart' || route === 'add') {
          // Importing the cart is an action the shopper takes once, by picking "Use my cart"
          // (or the cart-page/drawer equivalent, or confirming the replacement warning). It is
          // deliberately NOT part of resuming the cart route: the quote is an editable draft of
          // the cart, so re-pulling the cart on every page load would undo intentional removals
          // and quantity edits and leave the draft permanently pinned to the live cart.
          quoteLoaded = await refreshQuote({
            preserveSelection: true,
            silent: true,
            importFromCart: Boolean(options.explicitImport),
            replaceFromCart: Boolean(options.explicitImport),
          });
        }
        if (state.route !== route) return;
        showPanel(route, options);
        if (!quoteLoaded) {
          showNotice(
            route === 'cart'
              ? 'We could not load your cart. Please refresh and try again.'
              : 'We could not load your quote. Please refresh and try again.'
          );
        }
        if (route === 'add') hydrateVisualizerProducts();
      };

      const appendImage = (container, source, alt, className) => {
        if (source) {
          const image = document.createElement('img');
          image.className = className;
          image.src = source;
          image.alt = alt || '';
          image.loading = 'lazy';
          container.appendChild(image);
        } else {
          const placeholder = createElement('span', `${className} ${className}-placeholder`, '—');
          placeholder.setAttribute('aria-hidden', 'true');
          container.appendChild(placeholder);
        }
      };

      const appendPropertyList = (container, item) => {
        const properties = publicProperties(item);
        if (!properties.length) return;
        const heading = createElement('span', 'apq__item-meta', 'Selected options');
        container.appendChild(heading);
        const list = createElement('dl', 'apq__property-list');
        properties.forEach(([key, value]) => {
          const term = createElement('dt', '', key);
          const detail = createElement('dd');
          const stringValue = String(value);
          if (/^https?:\/\//i.test(stringValue)) {
            const link = createElement('a', '', 'View uploaded option');
            link.href = stringValue;
            link.target = '_blank';
            link.rel = 'noopener';
            detail.appendChild(link);
          } else {
            detail.textContent = stringValue;
          }
          list.append(term, detail);
        });
        container.appendChild(list);
      };

      const createIcon = (type) => {
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('focusable', 'false');
        svg.setAttribute('role', 'presentation');
        svg.setAttribute('aria-hidden', 'true');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('fill', 'currentColor');
        if (type === 'minus') {
          svg.setAttribute('class', 'apq__icon--minus');
          svg.setAttribute('viewBox', '0 0 10 2');
          path.setAttribute('d', 'M10 0v2H0V0z');
        } else {
          svg.setAttribute('class', 'apq__icon--plus');
          svg.setAttribute('viewBox', '0 0 10 10');
          path.setAttribute('d', 'M6 4h4v2H6v4H4V6H0V4h4V0h2v4z');
          path.setAttribute('fill-rule', 'evenodd');
        }
        svg.appendChild(path);
        return svg;
      };

      const createEditConfigIcon = () => {
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('class', 'apq__edit-config-icon');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'currentColor');
        svg.setAttribute('stroke-width', '1.75');
        svg.setAttribute('stroke-linecap', 'round');
        svg.setAttribute('stroke-linejoin', 'round');
        svg.setAttribute('focusable', 'false');
        svg.setAttribute('role', 'presentation');
        svg.setAttribute('aria-hidden', 'true');

        const body = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        body.setAttribute(
          'd',
          'M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z'
        );

        const detail = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        detail.setAttribute('d', 'm15 5 4 4');

        svg.append(body, detail);
        return svg;
      };

      const createItemCard = (item, options = {}) => {
        const article = createElement('article', 'apq__item');
        article.dataset.lineKey = item.key;
        appendImage(article, item.image, item.product_title || item.title, 'apq__item-image');

        const copy = createElement('div', 'apq__item-copy');
        const title = createElement('div', 'apq__item-title');
        const link = createElement('a', '', item.product_title || item.title || 'Product');
        link.href = item.url || '#';
        link.target = '_blank';
        link.rel = 'noopener';
        title.appendChild(link);
        copy.appendChild(title);

        const metaParts = [];
        if (item.variant_title && item.variant_title !== 'Default Title') metaParts.push(item.variant_title);
        if (item.sku) metaParts.push(`SKU ${item.sku}`);
        if (metaParts.length) copy.appendChild(createElement('div', 'apq__item-meta', metaParts.join(' · ')));
        appendPropertyList(copy, item);
        if (item.unavailable) {
          copy.appendChild(
            createElement('p', 'apq__item-unavailable', 'No longer available — remove or contact us to substitute.')
          );
        }
        if (options.editable && item.handle) {
          const editButton = document.createElement('button');
          editButton.type = 'button';
          editButton.className = 'apq__edit-config';
          editButton.dataset.editConfiguration = 'true';
          editButton.dataset.lineKey = item.key;
          editButton.dataset.productHandle = item.handle;
          if (item.url) editButton.dataset.productUrl = item.url;
          editButton.appendChild(createEditConfigIcon());
          editButton.append(labels.editConfiguration);
          copy.appendChild(editButton);
        }
        article.appendChild(copy);

        const side = createElement('div', 'apq__item-side');
        side.appendChild(createElement('strong', 'apq__item-price', money(item.final_line_price)));

        const qtyControls = createElement('div', 'apq__qty-controls');
        const selector = createElement('div', 'apq__quantity-selector');

        const decreaseButton = document.createElement('button');
        decreaseButton.type = 'button';
        decreaseButton.className = 'apq__quantity-button';
        decreaseButton.dataset.apqQtyChange = String(Math.max(item.quantity - 1, 0));
        decreaseButton.dataset.lineKey = item.key;
        decreaseButton.setAttribute('aria-label', labels.decrease);
        decreaseButton.title = labels.decrease;
        decreaseButton.appendChild(createIcon('minus'));

        const quantityInput = document.createElement('input');
        quantityInput.className = 'apq__quantity-value';
        quantityInput.type = 'number';
        quantityInput.inputMode = 'numeric';
        quantityInput.min = '0';
        quantityInput.step = '1';
        quantityInput.value = String(item.quantity);
        quantityInput.dataset.apqQtyInput = 'true';
        quantityInput.dataset.lineKey = item.key;
        quantityInput.dataset.currentValue = String(item.quantity);
        quantityInput.setAttribute('aria-label', labels.quantity);

        const increaseButton = document.createElement('button');
        increaseButton.type = 'button';
        increaseButton.className = 'apq__quantity-button';
        increaseButton.dataset.apqQtyChange = String(item.quantity + 1);
        increaseButton.dataset.lineKey = item.key;
        increaseButton.setAttribute('aria-label', labels.increase);
        increaseButton.title = labels.increase;
        increaseButton.appendChild(createIcon('plus'));

        selector.append(decreaseButton, quantityInput, increaseButton);
        qtyControls.appendChild(selector);

        const removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.className = 'apq__remove-line';
        removeButton.dataset.apqQtyChange = '0';
        removeButton.dataset.lineKey = item.key;
        removeButton.textContent = labels.remove;
        qtyControls.appendChild(removeButton);
        side.appendChild(qtyControls);
        article.appendChild(side);
        return article;
      };

      const setLineControlsDisabled = (disabled) => {
        queryAll('[data-apq-qty-change], [data-apq-qty-input]', root).forEach((control) => {
          control.disabled = disabled;
        });
      };

      const renderCart = () => {
        const cartItems = query('[data-cart-items]');
        const addItems = query('[data-add-items]');
        const cartEmpty = query('[data-cart-empty]');
        const addEmpty = query('[data-add-empty]');
        const addMore = query('[data-add-more]');
        cartItems.replaceChildren();
        addItems.replaceChildren();

        const items = state.cart?.items || [];
        renderVisualizerList();
        items.forEach((item) => {
          cartItems.appendChild(createItemCard(item));
          addItems.appendChild(createItemCard(item, { editable: true }));
        });

        cartEmpty.hidden = items.length > 0;
        addEmpty.hidden = items.length > 0;
        if (addMore) addMore.hidden = items.length === 0;
        queryAll('[data-panel="cart"] [data-next="project"], [data-panel="add"] [data-next="project"]').forEach(
          (button) => {
            button.disabled = includedItems().length === 0;
          }
        );
        syncUploadChrome();
        updateSummary();
      };

      const waitForRQ = () => {
        if (window.RQ && typeof window.RQ.toCartShape === 'function') {
          return Promise.resolve(window.RQ);
        }
        return new Promise((resolve, reject) => {
          const timeout = window.setTimeout(() => {
            document.removeEventListener('rq:ready', onReady);
            reject(new Error('Quote store unavailable'));
          }, 4000);
          const onReady = () => {
            window.clearTimeout(timeout);
            resolve(window.RQ);
          };
          document.addEventListener('rq:ready', onReady, { once: true });
        });
      };

      const applyQuoteToState = (options = {}) => {
        state.cart = window.RQ.toCartShape();
        state.includedKeys = new Set((state.cart.items || []).map((item) => item.key));
        state.hasInclusionSelection = true;
        renderCart();
        saveDraft();
      };

      // "Add products" quote items live only in RQ's own store, never the real Shopify cart,
      // so nothing re-prices or re-checks availability for them on its own. Re-fetch each
      // distinct product and reconcile price/availability so Refresh actually catches repriced
      // or discontinued items instead of just re-rendering the same stored data.
      const reconcileCatalog = async () => {
        const items = window.RQ.getItems();
        const handles = Array.from(new Set(items.map((item) => item.handle).filter(Boolean)));
        if (!handles.length) return { changed: false, unavailableCount: 0 };

        const productByHandle = new Map();
        await Promise.all(
          handles.map(async (handle) => {
            try {
              const response = await fetch(`${routesRoot}products/${encodeURIComponent(handle)}.js`, {
                credentials: 'same-origin',
                headers: { Accept: 'application/json' },
              });
              productByHandle.set(handle, response.ok ? await response.json() : null);
            } catch (error) {
              productByHandle.set(handle, null);
            }
          })
        );

        let changed = false;
        let unavailableCount = 0;
        for (const item of items) {
          const product = item.handle ? productByHandle.get(item.handle) : null;
          const variant = product?.variants?.find((candidate) => String(candidate.id) === String(item.variant_id));
          const patch = {};
          if (!product || !variant) {
            if (!item.unavailable) patch.unavailable = true;
          } else {
            if (item.unavailable) patch.unavailable = false;
            if (!variant.available) patch.unavailable = true;
            const optionPrice = Number(item.option_price) || 0;
            const currentPrice = (Number(variant.price) || 0) + optionPrice;
            if (currentPrice !== Number(item.price)) {
              patch.price = currentPrice;
              patch.original_price = Number(variant.price) || 0;
              patch.option_price = optionPrice;
              patch.line_price = currentPrice * item.quantity;
              patch.final_line_price = currentPrice * item.quantity;
            }
          }
          if (Object.keys(patch).length) {
            window.RQ.updateItem(item.key, patch);
            changed = true;
          }
          const isUnavailable = patch.unavailable !== undefined ? patch.unavailable : item.unavailable;
          if (isUnavailable) unavailableCount += 1;
        }
        return { changed, unavailableCount };
      };

      const refreshQuote = async (options = {}) => {
        try {
          await waitForRQ();
          let unavailableCount = 0;
          if (options.importFromCart) {
            await window.RQ.importCart(null, { replace: Boolean(options.replaceFromCart) });
          } else if (options.reconcileCatalog) {
            ({ unavailableCount } = await reconcileCatalog());
          }
          applyQuoteToState(options);
          if (!options.silent) {
            if (unavailableCount > 0) {
              showNotice(
                unavailableCount === 1
                  ? 'Products refreshed. 1 item is no longer available.'
                  : `Products refreshed. ${unavailableCount} items are no longer available.`
              );
            } else {
              showNotice(options.importFromCart ? 'Products refreshed from your cart.' : 'Products refreshed.');
            }
          }
          return true;
        } catch (error) {
          if (!options.silent) {
            showNotice(
              options.importFromCart
                ? 'We could not refresh your cart. Please try again.'
                : 'We could not refresh your quote. Please try again.'
            );
          }
          return false;
        }
      };

      const changeLineQuantity = async (lineKey, quantity) => {
        if (state.isUpdatingCart || !lineKey) return false;
        const nextQuantity = Number(quantity);
        if (!Number.isFinite(nextQuantity) || nextQuantity < 0) return false;

        state.isUpdatingCart = true;
        setLineControlsDisabled(true);
        hideNotice();

        const dropHandle = nextQuantity === 0 ? visualizerHandleForLineKey(lineKey) : '';

        try {
          await waitForRQ();
          window.RQ.updateQuantity(lineKey, nextQuantity);
          if (dropHandle) dropVisualizerHandle(dropHandle);
          applyQuoteToState({ preserveSelection: true });
          return true;
        } catch (error) {
          showNotice(error?.message || 'We could not update that product. Please try again.');
          applyQuoteToState({ preserveSelection: true });
          return false;
        } finally {
          state.isUpdatingCart = false;
          setLineControlsDisabled(false);
        }
      };

      const selectedValue = (name) => query(`[name="${CSS.escape(name)}"]:checked`, form)?.value || '';

      const selectedValues = (selector) => queryAll(`${selector}:checked`, form).map((field) => field.value);

      const syncProductsNeededField = () => {
        if (!productsNeededField) return;
        productsNeededField.value = selectedValues('[data-package-product]').join(', ');
      };

      const globoLooksSuccessful = () => {
        if (!globoHost || !state.globoSubmitAttempted) return false;
        if (globoHost.querySelector('.gfb-success, .form-success, .alert-success, .thankyou, [class*="thank-you"]')) {
          return true;
        }
        const text = (globoHost.textContent || '').replace(/\s+/g, ' ').toLowerCase();
        return (
          text.includes('thank you') ||
          text.includes('has been submitted') ||
          text.includes('we have received') ||
          text.includes('request is in')
        );
      };

      const showSuccessScreen = (email, reference) => {
        startScreen.hidden = true;
        flowScreen.hidden = true;
        successScreen.hidden = false;
        query('[data-success-reference]').textContent = reference || 'AQ-RECEIVED';
        query('[data-success-email]').textContent = email || 'your email';
        closeProductModal();
        clearProductSearch();
        syncUploadChrome();
      };

      // Phone contact is only offered once a phone number is entered; without one the
      // radio is disabled and any existing phone preference falls back to email.
      const syncPreferredContact = () => {
        const phoneField = query('[data-contact-phone]');
        const phoneRadio = query('[data-preferred-phone]');
        const emailRadio = query('[name="contact[Preferred contact]"][value="Email"]');
        if (!phoneField || !phoneRadio || !emailRadio) return;
        const hasPhone = phoneField.value.trim().length > 0;
        const choice = phoneRadio.closest('[data-preferred-phone-choice]');
        const hint = query('[data-preferred-phone-hint]');
        phoneRadio.disabled = !hasPhone;
        choice?.classList.toggle('is-disabled', !hasPhone);
        if (hint) hint.hidden = hasPhone;
        if (!hasPhone && phoneRadio.checked) {
          phoneRadio.checked = false;
          emailRadio.checked = true;
          return;
        }
        if (!emailRadio.checked && !phoneRadio.checked) {
          emailRadio.checked = true;
        }
      };

      const handleFromItem = (item) => {
        const direct = String(item?.handle || '').trim();
        if (direct) return direct;
        const match = String(item?.url || '').match(/\/products\/([^/?#]+)/);
        if (!match) return '';
        try {
          return decodeURIComponent(match[1]);
        } catch (error) {
          return match[1];
        }
      };

      const syncStudioLink = () => {
        const entries = queryAll('[data-studio-entry]');
        if (!entries.length) return;

        const handles = [];
        const seen = new Set();
        const items = !state.route || isUploadRoute() ? [] : includedItems();
        for (const item of items) {
          const handle = handleFromItem(item).toLowerCase();
          if (!handle || seen.has(handle)) continue;
          seen.add(handle);
          handles.push(handle);
        }

        const base = section.dataset.studioUrl || '/pages/bathroom-studio';
        const href = handles.length
          ? `${base}?from=quote&count=${handles.length}&products=${handles.map((handle) => encodeURIComponent(handle)).join(',')}`
          : '';

        for (const entry of entries) {
          const link = entry.querySelector('[data-studio-link]');
          if (!href) {
            entry.hidden = true;
            link?.removeAttribute('href');
            continue;
          }
          if (link) link.href = href;
          entry.hidden = false;
        }
      };

      const updateSummary = () => {
        syncStudioLink();
        summaryContent.replaceChildren();
        const items = includedItems();
        const files = isUploadRoute() ? globoFileNames() : [];
        const count = isUploadRoute() ? files.length : items.length;
        summaryCount.textContent = isUploadRoute()
          ? `${count} ${count === 1 ? 'file' : 'files'}`
          : `${count} ${count === 1 ? 'item' : 'items'}`;

        if (!state.route) {
          state.summaryExpanded = false;
          summaryContent.appendChild(createElement('p', 'apq__summary-meta', 'Choose how you would like to start.'));
          return;
        }

        const summaryPreviewLimit = 3;
        const summaryMoreLabel = (count) => labels.summaryMore.replaceAll('__COUNT__', String(count));
        const appendSummaryRows = (list, rows) => {
          const extraCount = Math.max(0, rows.length - summaryPreviewLimit);
          if (extraCount === 0) state.summaryExpanded = false;

          rows.forEach((contents, index) => {
            const item = createElement('li');
            if (index >= summaryPreviewLimit) {
              item.dataset.summaryExtra = 'true';
              item.hidden = !state.summaryExpanded;
            }
            item.append(...contents);
            list.appendChild(item);
          });

          if (extraCount === 0) return;

          const toggleItem = createElement('li', 'apq__summary-toggle-item');
          const toggle = createElement('button', 'apq__summary-toggle');
          toggle.type = 'button';
          toggle.setAttribute('aria-expanded', state.summaryExpanded ? 'true' : 'false');
          toggle.setAttribute('aria-controls', list.id);
          toggle.textContent = state.summaryExpanded ? labels.summaryLess : summaryMoreLabel(extraCount);
          toggle.addEventListener('click', () => {
            state.summaryExpanded = !state.summaryExpanded;
            queryAll('[data-summary-extra]', list).forEach((item) => {
              item.hidden = !state.summaryExpanded;
            });
            toggle.setAttribute('aria-expanded', state.summaryExpanded ? 'true' : 'false');
            toggle.textContent = state.summaryExpanded ? labels.summaryLess : summaryMoreLabel(extraCount);
          });
          toggleItem.appendChild(toggle);
          list.appendChild(toggleItem);
        };

        if (isUploadRoute()) {
          if (!files.length) {
            state.summaryExpanded = false;
            summaryContent.appendChild(
              createElement('p', 'apq__summary-meta', 'Uploaded files will appear here.')
            );
            return;
          }
          const list = createElement('ul', 'apq__summary-list');
          list.id = `AustpekQuoteSummaryList-${sectionId}`;
          appendSummaryRows(
            list,
            files.map((name) => [createElement('span', '', 'File'), createElement('span', '', name)])
          );
          summaryContent.appendChild(list);
          return;
        }

        if (!items.length) {
          state.summaryExpanded = false;
          summaryContent.appendChild(createElement('p', 'apq__summary-meta', 'No products selected yet.'));
          return;
        }

        const total = items.reduce((sum, item) => sum + Number(item.final_line_price || 0), 0);
        const totalRow = createElement('div', 'apq__summary-total');
        totalRow.append(
          createElement('span', '', 'Selected products subtotal'),
          createElement('span', '', money(total))
        );
        summaryContent.appendChild(totalRow);

        const list = createElement('ul', 'apq__summary-list');
        list.id = `AustpekQuoteSummaryList-${sectionId}`;
        appendSummaryRows(
          list,
          items.map((item) => [
            createElement('span', '', item.product_title || item.title || 'Product'),
            createElement(
              'span',
              '',
              publicProperties(item).length ? `Configured · Qty ${item.quantity}` : `Qty ${item.quantity}`
            ),
          ])
        );
        summaryContent.appendChild(list);
        summaryContent.appendChild(
          createElement('p', 'apq__summary-meta', 'Guide only. Final pricing is confirmed in your tailored quote.')
        );
      };

      const clearErrors = (scope) => {
        queryAll('[aria-invalid="true"]', scope).forEach((field) => field.removeAttribute('aria-invalid'));
        queryAll('.apq__fieldset.is-invalid', scope).forEach((group) => {
          group.classList.remove('is-invalid');
          group.removeAttribute('aria-invalid');
        });
        queryAll('.apq__field-error', scope).forEach((error) => {
          error.hidden = true;
        });
      };

      const markGroupInvalid = (group) => {
        group.classList.add('is-invalid');
        group.setAttribute('aria-invalid', 'true');
        queryAll('input[type="checkbox"], input[type="radio"]', group).forEach((input) => {
          input.setAttribute('aria-invalid', 'true');
        });
        const error = query(`[data-group-error="${group.dataset.requiredGroup}"]`, group);
        if (error) error.hidden = false;
      };

      const clearGroupInvalid = (group) => {
        group.classList.remove('is-invalid');
        group.removeAttribute('aria-invalid');
        queryAll('input[type="checkbox"], input[type="radio"]', group).forEach((input) => {
          input.removeAttribute('aria-invalid');
        });
        const error = query(`[data-group-error="${group.dataset.requiredGroup}"]`, group);
        if (error) error.hidden = true;
      };

      const validateRequiredFields = (panel) => {
        clearErrors(panel);
        let valid = true;
        let firstInvalid = null;
        queryAll('input, textarea, select', panel).forEach((field) => {
          if (field.type === 'hidden' || !field.willValidate || field.checkValidity()) return;
          valid = false;
          firstInvalid ||= field;
          field.setAttribute('aria-invalid', 'true');
          const error = field.closest('.apq__field')?.querySelector('.apq__field-error');
          if (error) error.hidden = false;
        });
        queryAll('[data-required-field]', panel).forEach((field) => {
          const value = field.value.trim();
          const isEmail = field.type === 'email';
          const fieldValid = value && field.checkValidity() && (!isEmail || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value));
          if (!fieldValid) {
            valid = false;
            firstInvalid ||= field;
            field.setAttribute('aria-invalid', 'true');
            const error = field.closest('.apq__field')?.querySelector('.apq__field-error');
            if (error) error.hidden = false;
          }
        });
        queryAll('[data-required-group]', panel).forEach((group) => {
          const checked = query('input:checked', group);
          if (!checked) {
            valid = false;
            markGroupInvalid(group);
            firstInvalid ||= query('input[type="checkbox"], input[type="radio"]', group) || group;
          }
        });
        if (firstInvalid) {
          if (
            typeof firstInvalid.reportValidity === 'function' &&
            firstInvalid.willValidate &&
            !firstInvalid.checkValidity()
          ) {
            firstInvalid.reportValidity();
          } else if (typeof firstInvalid.focus === 'function') {
            firstInvalid.focus({ preventScroll: true });
          }
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return valid;
      };

      const validateStepOne = () => {
        const valid = includedItems().length > 0;
        const error = query(state.route === 'cart' ? '[data-cart-error]' : '[data-add-error]');
        error.hidden = valid;
        return valid;
      };

      const validateContact = () => {
        const panel = query('[data-panel="contact"]');
        syncPreferredContact();
        return validateRequiredFields(panel);
      };

      const createReference = () => {
        try {
          const saved = sessionStorage.getItem(`${storageKey}-reference`);
          if (saved) return saved;
        } catch (error) {
          // Continue with an in-memory reference when storage is unavailable.
        }
        const date = new Date();
        const stamp = [
          String(date.getFullYear()).slice(-2),
          String(date.getMonth() + 1).padStart(2, '0'),
          String(date.getDate()).padStart(2, '0'),
        ].join('');
        const reference = `AQ-${stamp}-${Math.random().toString(36).slice(2, 7).toUpperCase()}`;
        try {
          sessionStorage.setItem(`${storageKey}-reference`, reference);
        } catch (error) {
          // The hidden contact field still carries this reference to Shopify.
        }
        return reference;
      };

      const finishQuoteSuccess = (email, reference) => {
        persistQuoteSuccessDetails({ email, reference });
        showSuccessScreen(email, reference);
        resetQuoteFlow();
        waitForRQ()
          .then(applyRqClear)
          .catch(() => {
            applyRqClear();
          });
      };

      const handleGloboSuccess = () => {
        if (state.globoSucceeded || !isUploadRoute()) return;
        state.globoSucceeded = true;
        const email = readGloboEmail() || globoEmailValue() || readQuoteSuccessDetails()?.email || 'your email';
        const reference = createReference();
        persistQuoteSuccessDetails({ email, reference });
        if (referenceField) referenceField.value = reference;

        const finish = () => finishQuoteSuccess(email, reference);

        if (typeof window.trackFormLead === 'function') window.trackFormLead();
        if (typeof window.trackMetaLead === 'function') window.trackMetaLead();
        if (typeof window.trackGoogleAdsLead === 'function') {
          window.trackGoogleAdsLead(finish);
        } else {
          finish();
        }
      };

      const watchGloboSubmission = () => {
        if (!globoHost || globoHost.dataset.apqWatch === 'true') return;
        globoHost.dataset.apqWatch = 'true';

        const maybeSucceed = (url, method, ok) => {
          if (!ok || !state.globoSubmitAttempted) return;
          if (!isUploadRoute() && !urlHasQuoteSent()) return;
          if (!isGloboSendRequest(url, method)) return;
          handleGloboSuccess();
        };

        const originalFetch = window.fetch;
        window.fetch = (...args) => {
          let input = args[0];
          let init = args[1];
          const url = String(input?.url || input || '');
          const method = String(init?.method || input?.method || 'GET').toUpperCase();
          if (state.globoSubmitAttempted && isGloboSendRequest(url, method)) {
            syncGloboReferenceField();
            if (init && Object.prototype.hasOwnProperty.call(init, 'body')) {
              init = { ...init, body: injectReferenceIntoBody(init.body) };
              args = [input, init];
            }
          }
          return originalFetch(...args).then((response) => {
            maybeSucceed(url, method, response.ok);
            return response;
          });
        };

        const originalOpen = XMLHttpRequest.prototype.open;
        const originalSend = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.open = function (method, url, ...rest) {
          this._apqGlobo = { method, url };
          return originalOpen.call(this, method, url, ...rest);
        };
        XMLHttpRequest.prototype.send = function (body, ...rest) {
          const meta = this._apqGlobo || {};
          if (state.globoSubmitAttempted && isGloboSendRequest(meta.url, meta.method)) {
            syncGloboReferenceField();
            body = injectReferenceIntoBody(body);
          }
          this.addEventListener('load', () => {
            maybeSucceed(meta.url, meta.method, this.status >= 200 && this.status < 300);
          });
          return originalSend.call(this, body, ...rest);
        };

        const observer = new MutationObserver(() => {
          if (globoLooksSuccessful()) handleGloboSuccess();
        });
        observer.observe(globoHost, { childList: true, subtree: true, characterData: true });
      };

      const buildQuoteBody = () => {
        const lines = [];
        lines.push(`AUSTPEK QUOTE REQUEST`);
        lines.push(`Reference: ${referenceField.value}`);
        lines.push(`Route: ${routeField.value}`);
        lines.push('');

        if (isUploadRoute()) {
          const files = globoFileNames();
          lines.push('UPLOADED PRODUCT LIST');
          if (files.length) files.forEach((name, index) => lines.push(`${index + 1}. ${name}`));
          else lines.push('File attached in the upload form.');
        } else {
          lines.push('CONFIGURED PRODUCTS');
          includedItems().forEach((item, index) => {
            lines.push(`${index + 1}. ${item.product_title || item.title || 'Product'}`);
            lines.push(`Line key: ${item.key}`);
            lines.push(`Variant: ${item.variant_title || 'Default'}`);
            lines.push(`Variant ID: ${item.variant_id || item.id || ''}`);
            lines.push(`SKU: ${item.sku || 'Not supplied'}`);
            lines.push(`Quantity: ${item.quantity}`);
            lines.push(`Line price: ${money(item.final_line_price)}`);
            const productUrl = item.url ? new URL(item.url, window.location.origin).href : '';
            lines.push(`Product URL: ${productUrl}`);
            const properties = allProperties(item);
            if (properties.length) {
              lines.push('Line item properties:');
              properties.forEach(([key, value]) => lines.push(`- ${key}: ${String(value)}`));
            } else {
              lines.push('Line item properties: None');
            }
            if (item.selling_plan_allocation?.selling_plan?.name) {
              lines.push(`Selling plan: ${item.selling_plan_allocation.selling_plan.name}`);
            }
            lines.push('');
          });
          lines.push(
            `Selected products subtotal: ${money(
              includedItems().reduce((sum, item) => sum + Number(item.final_line_price || 0), 0)
            )}`
          );
        }

        lines.push('');
        lines.push('PROJECT');
        lines.push(`Postcode: ${query('[name="contact[Project postcode]"]')?.value || ''}`);
        lines.push(`Timing: ${selectedValue('contact[Timing]')}`);
        lines.push(`Notes: ${query('[name="contact[Project notes]"]')?.value || 'Not supplied'}`);
        lines.push('');
        lines.push('This quote request does not place an order, reserve stock or change the customer cart.');
        return lines.join('\n');
      };

      const renderSearchResults = (products) => {
        const container = query('[data-search-results]');
        const status = query('[data-search-status]');
        container.replaceChildren();
        if (!products.length) {
          status.textContent = 'No matching products found.';
          return;
        }
        status.textContent = `${products.length} ${products.length === 1 ? 'product' : 'products'} found.`;
        products.forEach((product) => {
          const handle = getProductHandle(product);
          const article = createElement('article', 'apq__result');
          const imageUrl = product.featured_image?.url || product.image || '';
          appendImage(article, imageUrl, product.featured_image?.alt || product.title, 'apq__result-image');
          const copy = createElement('div', 'apq__result-copy');
          const title = createElement('div', 'apq__result-title');
          const titleLink = createElement('a', '', product.title);
          titleLink.href = product.url || (handle ? `${routesRoot}products/${handle}` : '#');
          titleLink.target = '_blank';
          titleLink.rel = 'noopener';
          title.appendChild(titleLink);
          copy.appendChild(title);
          if (isPresent(product.price)) {
            copy.appendChild(createElement('span', 'apq__result-price', `From ${money(Number(product.price) * 100)}`));
          }
          article.appendChild(copy);

          const action = document.createElement('button');
          action.type = 'button';
          action.className = 'apq__result-action';
          action.textContent = labels.add;
          action.setAttribute('aria-label', `${labels.add}: ${product.title}`);
          action.dataset.addProduct = 'true';
          action.dataset.productHandle = handle;
          action.dataset.productUrl = product.url || (handle ? `${routesRoot}products/${handle}` : '');
          action.dataset.productTitle = product.title || '';
          if (!handle && !action.dataset.productUrl) action.disabled = true;
          article.appendChild(action);
          container.appendChild(article);
        });
      };

      const getProductHandle = (product) => {
        if (product?.handle) return product.handle;
        if (!product?.url) return '';
        try {
          const path = new URL(product.url, window.location.origin).pathname;
          const match = path.match(/\/products\/([^/?#]+)/);
          return match ? decodeURIComponent(match[1]) : '';
        } catch (error) {
          return '';
        }
      };

      const parseVisualizerHandles = (raw) => {
        const source = Array.isArray(raw) ? raw.join(',') : String(raw || '');
        const handles = [];
        const seen = new Set();
        source.split(',').forEach((entry) => {
          let handle = '';
          try {
            handle = decodeURIComponent(String(entry || '').trim()).toLowerCase();
          } catch (error) {
            handle = String(entry || '').trim().toLowerCase();
          }
          handle = handle.replace(/^\/products\//, '').split(/[/?#]/)[0];
          if (!/^[a-z0-9][a-z0-9_-]*$/.test(handle) || seen.has(handle)) return;
          seen.add(handle);
          handles.push(handle);
        });
        return handles.slice(0, visualizerMaxProducts);
      };

      const readVisualizerRecord = () => {
        try {
          const raw =
            sessionStorage.getItem(visualizerStorageKey) || localStorage.getItem(visualizerStorageKey) || '';
          if (!raw) return { handles: [], products: {} };
          const parsed = JSON.parse(raw);
          if (Array.isArray(parsed)) {
            return { handles: parseVisualizerHandles(parsed), products: {} };
          }
          return {
            handles: parseVisualizerHandles(parsed?.handles || []),
            products: parsed?.products && typeof parsed.products === 'object' ? parsed.products : {},
          };
        } catch (error) {
          return { handles: [], products: {} };
        }
      };

      const persistVisualizerRecord = () => {
        const payload = JSON.stringify({
          handles: state.visualizerHandles,
          products: state.visualizerProducts,
        });
        try {
          sessionStorage.setItem(visualizerStorageKey, payload);
        } catch (error) {
          // Fall through to localStorage.
        }
        try {
          localStorage.setItem(visualizerStorageKey, payload);
        } catch (error) {
          // Storage may be unavailable.
        }
      };

      const dropVisualizerHandle = (handle) => {
        if (!handle) return false;
        const next = state.visualizerHandles.filter((entry) => entry !== handle);
        if (next.length === state.visualizerHandles.length) return false;
        state.visualizerHandles = next;
        delete state.visualizerProducts[handle];
        persistVisualizerRecord();
        return true;
      };

      const visualizerHandleForLineKey = (lineKey) => {
        if (!lineKey) return '';
        const item = (state.cart?.items || []).find((entry) => entry.key === lineKey);
        if (!item || !visualizerUsedKeys().has(lineKey)) return '';
        for (const handle of state.visualizerHandles) {
          if (visualizerItemMatches(item, handle, state.visualizerProducts[handle])) return handle;
        }
        return '';
      };

      const slimVisualizerProduct = (product) => {
        if (!product) return null;
        const featured = product.featured_image;
        const imageUrl =
          typeof featured === 'string' ? featured : featured?.src || featured?.url || product.image || '';
        return {
          id: product.id,
          handle: product.handle || '',
          title: product.title || '',
          url: product.url || (product.handle ? `${routesRoot}products/${product.handle}` : ''),
          price: product.price,
          featured_image: imageUrl,
        };
      };

      const visualizerItemMatches = (item, handle, product) => {
        if (!item) return false;
        const itemHandle = String(item.handle || getProductHandle(item) || '').toLowerCase();
        if (itemHandle && itemHandle === handle) return true;
        if (product?.id && String(item.product_id) === String(product.id)) return true;
        return false;
      };

      const createVisualizerPendingCard = (handle, product) => {
        const article = createElement('article', 'apq__result');
        article.dataset.visualizerHandle = handle;
        const title = product?.title || handle;
        const imageUrl =
          typeof product?.featured_image === 'string'
            ? product.featured_image
            : product?.featured_image?.url || product?.image || '';
        appendImage(article, imageUrl, title, 'apq__result-image');
        const copy = createElement('div', 'apq__result-copy');
        const titleWrap = createElement('div', 'apq__result-title');
        if (product?.url || handle) {
          const titleLink = createElement('a', '', title);
          titleLink.href = product?.url || `${routesRoot}products/${handle}`;
          titleLink.target = '_blank';
          titleLink.rel = 'noopener';
          titleWrap.appendChild(titleLink);
        } else {
          titleWrap.textContent = title;
        }
        copy.appendChild(titleWrap);
        if (!product) {
          const failed = Object.prototype.hasOwnProperty.call(state.visualizerProducts, handle);
          copy.appendChild(
            createElement(
              'span',
              'apq__result-price',
              failed ? labels.visualizerUnavailable : labels.visualizerLoading
            )
          );
          copy.appendChild(createVisualizerRemove(handle, title));
          article.appendChild(copy);
          return article;
        }
        if (isPresent(product.price)) {
          copy.appendChild(createElement('span', 'apq__result-price', `From ${money(Number(product.price))}`));
        }
        copy.appendChild(createVisualizerRemove(handle, title));
        article.appendChild(copy);
        const action = document.createElement('button');
        action.type = 'button';
        action.className = 'apq__result-action';
        action.textContent = labels.add;
        action.setAttribute('aria-label', `${labels.add}: ${title}`);
        action.dataset.addProduct = 'true';
        action.dataset.visualizerProduct = 'true';
        action.dataset.productHandle = handle;
        action.dataset.productUrl = product.url || `${routesRoot}products/${handle}`;
        action.dataset.productTitle = product.title || '';
        article.appendChild(action);
        return article;
      };

      const createVisualizerRemove = (handle, title) => {
        const removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.className = 'apq__remove-line';
        removeButton.dataset.removeVisualizer = handle;
        removeButton.textContent = labels.remove;
        removeButton.style.justifySelf = 'start';
        removeButton.setAttribute('aria-label', `${labels.remove}: ${title}`);
        return removeButton;
      };

      const visualizerUsedKeys = () => {
        const usedKeys = new Set();
        const items = state.cart?.items || [];
        state.visualizerHandles.forEach((handle) => {
          const product = state.visualizerProducts[handle];
          const quoteItem = items.find(
            (item) => !usedKeys.has(item.key) && visualizerItemMatches(item, handle, product)
          );
          if (quoteItem) usedKeys.add(quoteItem.key);
        });
        return usedKeys;
      };

      const renderVisualizerList = () => {
        const usedKeys = visualizerUsedKeys();
        const block = query('[data-visualizer-block]');
        const container = query('[data-visualizer-results]');
        const status = query('[data-visualizer-status]');
        if (!block || !container) return usedKeys;

        // Rebuilding this list unmounts the Add button that opened the product modal. Skip
        // while the dialog is open so VO can finish painting, then redraw on close.
        if (state.productModalOpen) {
          state.visualizerNeedsRender = true;
          return usedKeys;
        }

        state.visualizerNeedsRender = false;
        const handles = state.visualizerHandles;
        if (!handles.length) {
          block.hidden = true;
          container.replaceChildren();
          if (status) status.textContent = '';
          return usedKeys;
        }

        // Products already in the quote stay in "Products in this quote"; this block lists only
        // the studio products still waiting to be added.
        const items = state.cart?.items || [];
        const claimed = new Set();
        const waiting = handles.filter((handle) => {
          const product = state.visualizerProducts[handle];
          const quoteItem = items.find(
            (item) => !claimed.has(item.key) && visualizerItemMatches(item, handle, product)
          );
          if (quoteItem) claimed.add(quoteItem.key);
          return !quoteItem;
        });

        container.replaceChildren();
        if (!waiting.length) {
          block.hidden = true;
          if (status) status.textContent = '';
          return usedKeys;
        }

        block.hidden = false;
        waiting.forEach((handle) => {
          container.appendChild(createVisualizerPendingCard(handle, state.visualizerProducts[handle] || null));
        });

        if (status) {
          const pending = waiting.some((handle) => !(handle in state.visualizerProducts));
          status.textContent = pending
            ? labels.visualizerLoading
            : labels.visualizerStatus.replace('__COUNT__', String(waiting.length));
        }
        return usedKeys;
      };

      const hydrateVisualizerProducts = async () => {
        const handles = state.visualizerHandles;
        const block = query('[data-visualizer-block]');
        if (!handles.length) {
          if (block) block.hidden = true;
          renderVisualizerList();
          return;
        }
        if (block) block.hidden = false;
        state.visualizerHydrating = true;
        renderVisualizerList();
        await Promise.all(
          handles.map(async (handle) => {
            try {
              const response = await fetch(`${routesRoot}products/${encodeURIComponent(handle)}.js`, {
                credentials: 'same-origin',
                headers: { Accept: 'application/json' },
              });
              if (!state.visualizerHandles.includes(handle)) return;
              if (!response.ok) {
                if (!(handle in state.visualizerProducts)) state.visualizerProducts[handle] = null;
                return;
              }
              state.visualizerProducts[handle] = slimVisualizerProduct(await response.json());
            } catch (error) {
              if (!state.visualizerHandles.includes(handle)) return;
              if (!(handle in state.visualizerProducts)) state.visualizerProducts[handle] = null;
            }
          })
        );
        state.visualizerHydrating = false;
        persistVisualizerRecord();
        renderVisualizerList();
      };

      const extractQuoteProduct = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fromView = doc.querySelector('[data-apq-quote-product]');
        if (fromView) return document.importNode(fromView, true);

        const templates = Array.from(doc.querySelectorAll('template'));
        for (const template of templates) {
          const node = template.content.querySelector(
            '[data-section-type="product-quick-view"], [data-apq-quote-product]'
          );
          if (node) return document.importNode(node, true);
        }

        const fallback = doc.querySelector('[data-section-type="product-quick-view"]');
        return fallback ? document.importNode(fallback, true) : null;
      };

      const extractAndRunScripts = (html, container) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('script').forEach((sourceScript) => {
          if (sourceScript.src) return;
          const script = document.createElement('script');
          script.textContent = sourceScript.textContent;
          (container || document.body).appendChild(script);
          script.remove();
        });
      };

      const reinitalizeVoOptions = (container) => {
        const productId = container?.dataset?.productId;
        try {
          if (typeof window.bcpo_product !== 'undefined' && productId) {
            if (Array.isArray(window.bcpo_product)) {
              const match = window.bcpo_product.find((item) => String(item.id) === String(productId));
              if (match) window.bcpo_product = match;
            }
          }

          // The fetched page's own scripts set these globals just before this runs, and the
          // request token already rules out a late response, so they should always be this
          // product's. `bcpo_product.id` is the identity to check -- it is the product itself.
          // If it is someone else's, painting nothing beats painting their options; the
          // editor's hydration check then offers Retry.
          const globalsProductId = window.bcpo_product?.id;
          const ownsGlobals =
            !productId || globalsProductId == null || String(globalsProductId) === String(productId);

          if (window.bcpo && typeof window.bcpo === 'object') {
            window.bcpo.finished = false;
            window.bcpo.addToCart = undefined;
          }
          delete window.bcpoRan;

          // No product-id check on `bcpo_data`, though. Its `product_id` is the product the option
          // set was built on, not the one rendering it: colourways share one set, so LUKKA
          // CHESTER MATTE WHITE 750MM (9024508756182) carries a config stamped 9025451786454.
          // Nulling that on a mismatch left the widget with only the variant swatches -- no
          // Configuration, no Handle Options -- and "Edit configuration" then waited out every
          // field timeout before showing "We could not restore every saved option". Stale
          // configs are already ruled out upstream: clearBcpoProductState wipes the globals
          // before each fetched product's own scripts set them, and restoreBcpoGlobals puts a
          // cached node's own globals back.

          if (typeof window.bcpoFunction === 'function' && window.bcpo_product && ownsGlobals) {
            // Re-assert here as well as in clearBcpoProductState: the previous product's render
            // is a multi-tick state machine, so it can set these guards again between that call
            // and this one, and the pass that applies conditional visibility would then be
            // skipped for the product we are about to paint.
            clearBcpoInitGuards();
            const form = container?.querySelector?.('form[action*="/cart/add"]');
            const $form = form && typeof window.bcpo?.$ === 'function' ? window.bcpo.$(form) : null;
            if ($form && window.bcpo) window.bcpo.oldForm = $form;
            window.bcpoFunction(
              window.bcpo_product,
              window.bcpo_settings,
              window.bcpo_data,
              $form || null,
              null
            );
          }

          if (typeof window.bcpo?.reload === 'function') window.bcpo.reload();
          if (typeof window.bcpo?.refresh === 'function') window.bcpo.refresh();
          if (typeof window.bcpo?.init === 'function') window.bcpo.init();
          if (typeof window.BCPO?.init === 'function') window.BCPO.init();
          if (typeof window.BCPO?.load === 'function') window.BCPO.load();

          document.dispatchEvent(new CustomEvent('bcpo:load', { detail: { productId } }));
          document.dispatchEvent(new CustomEvent('vo:options:reload', { detail: { productId } }));

          const placeholder = container?.querySelector('.bcpo-quickview, #bcpo');
          if (placeholder) {
            placeholder.setAttribute('data-apq-vo-ready', String(Date.now()));
          }
        } catch (error) {
          // VO reinits are best-effort; form still works for plain variants.
        }
      };

      // `delete` cannot remove these. templates/product.apq-quote.liquid ends its inline script
      // with top-level `var bcpo_product = ...` / `var bcpo_data = ...`, and a top-level `var`
      // creates a NON-CONFIGURABLE property on `window` — so from the second product onward the
      // delete silently returned false and left the previous product's config in place. The next
      // product's `window.bcpo_data = window.bcpo_data || null` then kept it, and the options app
      // rendered the previous product's option groups onto the new product (a handle offering
      // "Undermount Top" and "Pop-up Waste"). Assign over them instead.
      const clearBcpoGlobal = (name) => {
        try {
          if (delete window[name]) return;
        } catch (error) {
          // Non-configurable: the delete throws instead of returning false in strict mode.
        }
        window[name] = undefined;
      };

      // The options app applies its conditional logic ("show the 900mm fields only when 900mm
      // is picked") from a pass that is guarded by a page-lifetime flag: on a synthetic change
      // -- which is what its own first render fires -- it returns immediately once
      // `window.bcpo_init_done` is set, and the sibling pass that fills the `.bcpo-value`
      // summaries returns once `window.bcpo_init_done_oe` is set. Both are meant to run once per
      // page load, but this modal loads a new product into the same page, so the second product
      // onward got its options rendered with the conditional pass skipped: every branch of
      // TIMBERLINE NEVADA (600/900/1200/1500mm) stayed visible at once, 206 option groups in a
      // dialog that scrolled to 114,495px. Clearing them makes each modal load look like a fresh
      // page load to the widget. Real shopper input carries `originalEvent`, which bypasses the
      // guard entirely, so resetting these never re-runs anything the shopper already did.
      const clearBcpoInitGuards = () => {
        ['bcpo_init_done', 'bcpo_init_done_oe'].forEach(clearBcpoGlobal);
      };

      const clearBcpoProductState = () => {
        ['bcpoRan', 'bcpo_product', 'bcpo_data', 'inventory_quantity'].forEach(clearBcpoGlobal);
        clearBcpoInitGuards();
        if (window.bcpo && typeof window.bcpo === 'object') {
          window.bcpo.finished = false;
        }
      };

      // The VO/BCPO widget reads its product from page globals that the next product's fetch
      // overwrites. Cached nodes outlive that, so keep each node's globals with it and put them
      // back before the shopper interacts with a reused form — otherwise its live handlers
      // price and validate against whichever product happened to be loaded last.
      const bcpoGlobalsByNode = new WeakMap();

      const rememberBcpoGlobals = (node) => {
        if (!node) return;
        bcpoGlobalsByNode.set(node, {
          product: window.bcpo_product,
          data: window.bcpo_data,
          settings: window.bcpo_settings,
          inventory: window.inventory_quantity,
        });
      };

      const restoreBcpoGlobals = (node) => {
        const globals = bcpoGlobalsByNode.get(node);
        if (!globals) return;
        if (globals.product !== undefined) window.bcpo_product = globals.product;
        if (globals.data !== undefined) window.bcpo_data = globals.data;
        if (globals.settings !== undefined) window.bcpo_settings = globals.settings;
        if (globals.inventory !== undefined) window.inventory_quantity = globals.inventory;
      };

      const syncModalSubmitLabel = (container) => {
        const label = state.editingLineKey ? labels.saveConfiguration : labels.add;
        container?.querySelectorAll('[data-action="add-to-cart"]').forEach((button) => {
          button.textContent = label;
          button.setAttribute('aria-label', label);
        });
      };

      const propertySelector = (name) => {
        const escaped =
          typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
            ? CSS.escape(String(name))
            : String(name).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        return `[name="properties[${escaped}]"], [name="properties[${escaped}][]"]`;
      };

      const dispatchFieldUpdate = (field) => {
        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.dispatchEvent(new Event('change', { bubbles: true }));
      };

      const optionContextRoots = (container) => {
        const quoteRoot = container.querySelector('[data-apq-quote-product]') || container;
        const form = quoteRoot.querySelector('form[action*="/cart/add"]');
        const roots = [];
        const seen = new Set();
        const add = (node) => {
          if (!node || seen.has(node)) return;
          seen.add(node);
          roots.push(node);
        };
        add(form);
        add(quoteRoot);
        add(form?.closest('product-form'));
        add(quoteRoot.querySelector('#bcpo, .bcpo-quickview'));
        return roots.filter(Boolean);
      };

      // Adding a configured product to the real Shopify cart is the one path that does not
      // store what the option widget's own fields carry. Its cart payload builder appends the
      // option's surcharge to the line-item property -- `value + " | " + formatMoney(...)` for a
      // single-select group, and the same suffix once after the joined list for a multi-select.
      // So a quote line imported from the cart holds "Undermount Top | $1,040.00" where the
      // radio it came from is still plain "Undermount Top", and every comparison here missed:
      // "Edit configuration" then spent its full per-property timeout waiting for a field that
      // could not exist, ~49s in all, and finished with the branch group unset, its dependent
      // groups gone and "We could not restore every saved option for this product". Strip the
      // suffix on both sides so a cart line replays exactly like one added from a product page.
      // The stored value keeps the suffix: RQ prices cart lines off it (#optionPriceFromProperties).
      const OPTION_PRICE_SUFFIX = /\s*\|\s*[-+]?[$€£¥]\s?\d[\d.,']*(?:\s*[A-Z]{3})?(?=\s*(?:,|$))/g;

      const stripOptionPrice = (value) => String(value == null ? '' : value).replace(OPTION_PRICE_SUFFIX, '');

      const normalizeOptionLabel = (value) =>
        stripOptionPrice(value)
          .replace(/\(\+\s*\$[^)]+\)/g, '')
          .replace(/\s+/g, ' ')
          .trim();

      // Every `[name="properties[...]"]` field in the modal, visited once. `optionContextRoots`
      // returns nested roots (the form contains #bcpo, the quote root contains the form), so
      // iterating them naively hands back the same field three or four times.
      const forEachPropertyField = (container, callback) => {
        const seen = new Set();
        optionContextRoots(container).forEach((root) => {
          root.querySelectorAll('[name^="properties"]').forEach((field) => {
            if (seen.has(field)) return;
            seen.add(field);
            const match = String(field.name).match(/^properties\[(.+?)\](?:\[\])?$/);
            if (!match) return;
            callback(field, match[1]);
          });
        });
      };

      const clearPropertyField = (field) => {
        if (field.type === 'radio' || field.type === 'checkbox') {
          if (!field.checked) return;
          field.checked = false;
          dispatchFieldUpdate(field);
          return;
        }
        if (field.tagName === 'SELECT') {
          if (field.selectedIndex <= 0) return;
          field.selectedIndex = 0;
          dispatchFieldUpdate(field);
          return;
        }
        if (field.type === 'file') return;
        if (!String(field.value || '')) return;
        field.value = '';
        dispatchFieldUpdate(field);
      };

      // The modal reuses one rendered product node per product (state.modalCache), so whatever
      // the previous open left selected is still sitting in the DOM. Clear every option group
      // the target configuration does not mention before replaying it, otherwise "Edit
      // configuration" shows the saved options mixed with the last-used ones. VO's own
      // `_`-prefixed bookkeeping fields are left alone.
      const clearStaleProperties = (container, keepNames) => {
        const keep = new Set(keepNames || []);
        forEachPropertyField(container, (field, name) => {
          if (keep.has(name) || String(name).startsWith('_')) return;
          clearPropertyField(field);
        });
      };

      // The group that drives a product's conditional branches is not always called exactly
      // "Configuration": the vanity ranges name it per size -- "Configuration (1500mm)",
      // "Configuration 1800D". Matching only the bare name left those unrecognised, so the
      // replay fell back to alphabetical order and tried to set a branch's dependants before
      // the option that creates them. A 1500mm Nevada Plus on "Above Counter Top" asked for
      // "Above Counter Basin (1500mm)" and "Above Counter Top Options (1500mm)" first: both
      // spent the full field timeout waiting for fields that could not exist yet, exhausting
      // the retry budget before the branch itself was applied, and the shopper got "We could
      // not restore every saved option for this product". Ranges whose dependants happen to
      // sort after "Configuration" (1800D's "Undermount ...", "Taphole ...") only worked by
      // luck of the alphabet.
      const isConfigurationProperty = (name) => /^Configuration\b/i.test(String(name || '').trim());

      const orderedPropertyEntries = (item) => {
        const entries = publicProperties(item);
        const configuration = entries.find(([name]) => isConfigurationProperty(name));
        // Normalised, not raw: a cart-imported line reads "Undermount Top | $1,040.00", and the
        // group it opens is named after the plain option ("Undermount Top Options (900mm)"), so
        // the raw value matched no branch and the ordering fell back to the alphabet.
        const configurationValue = normalizeOptionLabel(configuration?.[1]);
        const rest = entries.filter((entry) => entry !== configuration);
        // A branch's own sub-group is named after the value that opened it ("Above Counter Top"
        // -> "Above Counter Top Options (1500mm)"), and it in turn opens further groups, so it
        // has to be applied before the rest of the alphabet too.
        const isBranchGroup = (name) =>
          Boolean(configurationValue) && String(name).startsWith(String(configurationValue));
        rest.sort((left, right) => {
          const leftIsBranch = isBranchGroup(left[0]);
          const rightIsBranch = isBranchGroup(right[0]);
          if (leftIsBranch && !rightIsBranch) return -1;
          if (!leftIsBranch && rightIsBranch) return 1;
          return left[0].localeCompare(right[0]);
        });
        return configuration ? [configuration, ...rest] : rest;
      };

      // Mirrors RQ.#parseForm so what we compare against a saved line is exactly what a save
      // would write back. Visiting a field twice used to turn "White" into "White, White",
      // which made every configuration look mismatched and sent the restore into its retry loop.
      const readModalProperties = (container) => {
        const properties = {};
        forEachPropertyField(container, (field, name) => {
          if (field.disabled) return;
          if ((field.type === 'radio' || field.type === 'checkbox') && !field.checked) return;
          const value = String(field.value || '').trim();
          if (!value) return;
          properties[name] = properties[name] ? `${properties[name]}, ${value}` : value;
        });
        return properties;
      };

      const publicPropertyMap = (properties) => {
        const map = {};
        Object.entries(properties || {}).forEach(([key, value]) => {
          if (!isPresent(value) || String(key).startsWith('_')) return;
          map[key] = normalizeOptionLabel(value);
        });
        return map;
      };

      const configurationMatchesItem = (container, item) => {
        const expected = publicPropertyMap(item?.properties);
        const actual = publicPropertyMap(readModalProperties(container));
        const expectedKeys = Object.keys(expected);
        const actualKeys = Object.keys(actual);

        // Both directions: a leftover selection from a previous open is just as wrong as a
        // missing one, and only the reverse check catches it.
        if (
          expectedKeys.length === actualKeys.length &&
          expectedKeys.every((key) => actual[key] === expected[key])
        ) {
          return true;
        }
        if (actualKeys.length > expectedKeys.length) return false;

        // Some VO groups paint the chosen value into a summary node instead of a form field.
        // Accept those via the rendered labels rather than replaying the whole configuration.
        if (!expectedKeys.length) return false;
        const summaryLabels = [...container.querySelectorAll('.bcpo-value')]
          .map((element) => normalizeOptionLabel(element.textContent))
          .filter(Boolean);
        if (!summaryLabels.length) return false;
        return expectedKeys.every((key) => {
          if (actual[key] === expected[key]) return true;
          return summaryLabels.some(
            (label) => label === expected[key] || label.includes(expected[key])
          );
        });
      };

      const activateChoiceField = (field) => {
        const fieldId = field.id ? String(field.id) : '';
        const escapedId =
          fieldId && typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
            ? CSS.escape(fieldId)
            : fieldId.replace(/"/g, '\\"');
        const label =
          field.labels?.[0] ||
          (fieldId
            ? field.parentElement?.querySelector(`label[for="${escapedId}"]`) ||
              field.closest('.bcpo-button-parent, li, label')?.querySelector('label')
            : field.closest('label') || field.parentElement?.querySelector('label'));
        (label || field).click();
      };

      const selectPropertyField = (field, shouldSelect) => {
        if (field.type === 'radio' || field.type === 'checkbox') {
          if (shouldSelect && !field.checked) {
            activateChoiceField(field);
            return field.checked;
          }
          if (!shouldSelect && field.checked && field.type === 'checkbox') {
            activateChoiceField(field);
            return !field.checked;
          }
          return shouldSelect && field.checked;
        }
        if (field.tagName === 'SELECT') {
          field.value = shouldSelect;
          dispatchFieldUpdate(field);
          return field.value === shouldSelect;
        }
        if (field.type === 'file') return false;
        field.value = shouldSelect;
        dispatchFieldUpdate(field);
        return normalizeOptionLabel(field.value) === normalizeOptionLabel(shouldSelect);
      };

      // Visit each field matching `selector` once. `optionContextRoots` returns nested roots,
      // so a plain per-root loop re-visits every field and fires a redundant change event on it
      // — which the option widget then re-renders on, slowing the replay down.
      const forEachOptionField = (container, selector, callback) => {
        const seen = new Set();
        optionContextRoots(container).forEach((root) => {
          root.querySelectorAll(selector).forEach((field) => {
            if (seen.has(field)) return;
            seen.add(field);
            callback(field);
          });
        });
      };

      const applyPropertyValueByLabel = (container, rawValue) => {
        const target = normalizeOptionLabel(rawValue);
        if (!target) return false;

        let applied = false;
        forEachOptionField(
          container,
          'input[type="radio"], input[type="checkbox"], .bcpo-front-button-option',
          (field) => {
            if (normalizeOptionLabel(field.value) !== target) return;
            if (selectPropertyField(field, true)) applied = true;
          }
        );
        return applied;
      };

      const applyPropertyValue = (container, name, rawValue) => {
        if (!isPresent(rawValue) || String(name).startsWith('_')) return false;
        const fields = [];
        forEachOptionField(container, propertySelector(name), (field) => fields.push(field));
        const values = matchableValues(
          rawValue,
          fields.flatMap((field) =>
            field.tagName === 'SELECT'
              ? [...field.options].map((option) => normalizeOptionLabel(option.value))
              : [normalizeOptionLabel(field.value)]
          )
        );
        if (!values.length) return false;

        let applied = false;
        fields.forEach((field) => {
          if (field.type === 'radio') {
            const shouldSelect = values.includes(normalizeOptionLabel(field.value));
            if (selectPropertyField(field, shouldSelect) && shouldSelect) applied = true;
            return;
          }
          if (field.type === 'checkbox') {
            if (selectPropertyField(field, values.includes(normalizeOptionLabel(field.value)))) applied = true;
            return;
          }
          if (field.tagName === 'SELECT') {
            const match = values.find((entry) =>
              Array.from(field.options).some((option) => normalizeOptionLabel(option.value) === entry)
            );
            const option = match
              ? Array.from(field.options).find((candidate) => normalizeOptionLabel(candidate.value) === match)
              : null;
            if (option && selectPropertyField(field, option.value)) applied = true;
            return;
          }
          if (field.type === 'file') return;
          // Free-text fields take the value verbatim, so write the label without the cart's
          // surcharge suffix — otherwise saving would store "Custom size | $80.00" back.
          if (selectPropertyField(field, stripOptionPrice(rawValue))) applied = true;
        });

        return applied;
      };

      const wait = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

      // Strip the cart's surcharge suffix before splitting: a multi-select line reads
      // "Above Counter Top, Splashback | $260.00", so splitting first would leave the last
      // chosen option carrying a price no option value has, and "$1,040.00" in a single-select
      // line would split on its own thousands separator into "Undermount Top | $1" and "040.00".
      const propertyValues = (rawValue) =>
        stripOptionPrice(rawValue)
          .split(',')
          .map((entry) => normalizeOptionLabel(entry))
          .filter(Boolean);

      // A multi-select group is read back as its chosen values joined with ", ", so the replay
      // splits a saved value on commas to reverse that. Some single options carry a comma in
      // their own label -- "SilkSurface Splashback – 180mm Height, Square Corners
      // (TOP-OPT-SB-S)" -- and splitting shredded those into two fragments that matched no
      // option at all: the field was never selected, its wait ran out, and the shopper got
      // "We could not restore every saved option for this product". Whenever an option carries
      // the whole value verbatim, that is the one that was saved; only fall back to splitting
      // when none does, which keeps genuine multi-selects restoring as before.
      const matchableValues = (rawValue, fieldValues) => {
        const whole = normalizeOptionLabel(rawValue);
        if (whole && fieldValues.some((value) => value === whole)) return [whole];
        return propertyValues(rawValue);
      };

      const propertyFieldExists = (container, name, rawValue) => {
        const whole = normalizeOptionLabel(rawValue);
        const values = propertyValues(rawValue);
        if (!values.length) return false;
        const carriesValue = (field) => {
          const fieldValue = normalizeOptionLabel(field.value);
          return (whole && fieldValue === whole) || values.includes(fieldValue);
        };
        return optionContextRoots(container).some((root) => {
          const named = [...root.querySelectorAll(propertySelector(name))];
          if (named.some(carriesValue)) return true;
          return [...root.querySelectorAll('input[type="radio"], input[type="checkbox"], .bcpo-front-button-option')].some(
            carriesValue
          );
        });
      };

      const neverStale = () => false;

      const waitForPropertyField = async (container, name, rawValue, timeout = 6000, isStale = neverStale) => {
        const started = Date.now();
        while (Date.now() - started < timeout) {
          if (propertyFieldExists(container, name, rawValue)) return true;
          if (isStale()) return false;
          await wait(80);
        }
        return false;
      };

      // The widget draws a product's own Shopify variants ("Drawer Option") as its swatches
      // too, so swatches on screen are not proof its custom groups made it. When they did not,
      // the modal showed only the drawer choice, was cached as "ready" and reused like that on
      // every reopen. A product whose config declares custom groups is hydrated only once at
      // least one `properties[...]` field exists; VO renders every group, conditional ones
      // included, and hides the inactive ones rather than leaving them out.
      const expectsCustomOptions = (quoteRoot) => {
        const remembered = quoteRoot ? bcpoGlobalsByNode.get(quoteRoot) : null;
        const data = remembered?.data !== undefined ? remembered.data : window.bcpo_data;
        return Array.isArray(data?.virtual_options) && data.virtual_options.length > 0;
      };

      const customOptionsHydrated = (quoteRoot) =>
        !expectsCustomOptions(quoteRoot) ||
        Boolean(quoteRoot?.querySelector('#bcpo [name^="properties"], .bcpo-quickview [name^="properties"]'));

      const bcpoHasRendered = (container) => {
        const quoteRoot = container.querySelector('[data-apq-quote-product]') || container;
        const bcpo = quoteRoot.querySelector('#bcpo, .bcpo-quickview');
        return (
          Boolean(bcpo?.querySelector('.bcpo-front-button-option, .bcpo-front-image-option, [name^="properties"]')) &&
          customOptionsHydrated(quoteRoot)
        );
      };

      const waitForBcpoReady = async (container, item, timeout = 8000, isStale = neverStale) => {
        const entries = item ? orderedPropertyEntries(item) : [];
        if (entries.length) {
          const [name, value] = entries[0];
          return waitForPropertyField(container, name, value, timeout, isStale);
        }

        const started = Date.now();
        while (Date.now() - started < timeout) {
          if (bcpoHasRendered(container)) return true;
          if (isStale()) return false;
          await wait(80);
        }
        return false;
      };

      // The options widget replaces the theme's variant `<select>` with swatches of its own and
      // drives the select from them, never the other way round. Setting the select alone
      // therefore restored the saved variant while the widget still showed -- and applied its
      // conditional logic from -- the product's default option values. Re-opening a saved 900MM
      // Nevada showed 600mm picked with the "Configuration (600mm)" group exposed, and saving
      // without touching anything rewrote the line's `Configuration (900mm)` property to
      // `Configuration (600mm)` against an unchanged 900MM variant. Move the widget's own
      // swatches so both halves agree before any property is replayed onto them.
      const syncOptionSwatchesToVariant = (quoteRoot, variantTitle) => {
        const optionsRoot = quoteRoot?.querySelector('#bcpo, .bcpo-quickview');
        if (!optionsRoot || !variantTitle) return;

        // Shopify builds a variant title by joining its option values with " / ".
        const values = String(variantTitle)
          .split(' / ')
          .map((value) => value.trim())
          .filter(Boolean);

        values.forEach((value, index) => {
          const group =
            optionsRoot.querySelector(`.single-option-selector[data-option="option${index + 1}"]`) ||
            optionsRoot.querySelector(`#bcpo-select-option-${index}`);
          if (!group) return;

          const matches = (candidate) =>
            String(candidate).trim().toLowerCase() === value.toLowerCase();

          if (group.tagName === 'SELECT') {
            if (matches(group.value)) return;
            const option = [...group.options].find((entry) => matches(entry.value));
            if (!option) return;
            group.value = option.value;
            dispatchFieldUpdate(group);
            return;
          }

          const field = [...group.querySelectorAll('input[type="radio"], input[type="checkbox"]')].find(
            (input) => matches(input.value)
          );
          // Already on the saved value: clicking again would re-fire the widget's conditional
          // pass for no reason, and on a checkbox it would clear the selection.
          if (!field || field.checked) return;
          activateChoiceField(field);
        });
      };

      const applyVariantAndQuantity = (container, item) => {
        const quoteRoot = container?.querySelector('[data-apq-quote-product]') || container;
        const form = quoteRoot?.querySelector('form[action*="/cart/add"]');
        if (!form || !item) return;

        const variantId = String(item.variant_id || item.id || '');
        if (variantId) {
          const variantSelect = form.querySelector('select[name="id"]');
          const variantHidden = form.querySelector('input[name="id"]');
          const variantOption = variantSelect?.querySelector(`option[value="${variantId}"]`);
          if (variantOption) {
            if (variantSelect.value !== variantId) {
              variantSelect.value = variantId;
              dispatchFieldUpdate(variantSelect);
            }
            syncOptionSwatchesToVariant(
              quoteRoot,
              variantOption.dataset.variantTitle || item.variant_title || ''
            );
          } else if (variantHidden && variantHidden.value !== variantId) {
            variantHidden.value = variantId;
            dispatchFieldUpdate(variantHidden);
          }
        }

        const qtyInput = form.querySelector('[name="quantity"]');
        const quantity = Number(item.quantity) || 0;
        if (qtyInput && quantity && qtyInput.value !== String(quantity)) {
          qtyInput.value = String(quantity);
          dispatchFieldUpdate(qtyInput);
        }
      };

      const applyItemConfigurationToForm = async (container, item, isStale = neverStale) => {
        if (!container || !item) return false;

        const quoteRoot = container.querySelector('[data-apq-quote-product]') || container;
        const form = quoteRoot.querySelector('form[action*="/cart/add"]');
        if (!form) return false;

        applyVariantAndQuantity(container, item);

        const entries = orderedPropertyEntries(item);
        clearStaleProperties(
          container,
          entries.map(([name]) => name)
        );

        for (const [name, value] of entries) {
          if (isStale()) return false;
          await waitForPropertyField(container, name, value, isConfigurationProperty(name) ? 6000 : 2500, isStale);
          if (isStale()) return false;
          if (!applyPropertyValue(container, name, value)) {
            propertyValues(value).forEach((entry) => {
              applyPropertyValueByLabel(container, entry);
            });
          }
          await wait(isConfigurationProperty(name) ? 280 : 90);
        }

        updateModalPrice(quoteRoot);
        return configurationMatchesItem(container, item);
      };

      const applyItemConfigurationWithRetry = async (container, item, isStale = neverStale, deadline = Infinity) => {
        await waitForBcpoReady(container, item, 8000, isStale);
        if (isStale()) return false;
        if (await applyItemConfigurationToForm(container, item, isStale)) return true;
        if (isStale()) return false;

        const quoteRoot = container.querySelector('[data-apq-quote-product]') || container;
        const bcpo = quoteRoot.querySelector('#bcpo, .bcpo-quickview');
        if (!bcpo) return false;

        return new Promise((resolve) => {
          let finished = false;
          let debounceId = 0;
          const finish = (matched) => {
            if (finished) return;
            finished = true;
            observer.disconnect();
            window.clearTimeout(timeoutId);
            window.clearTimeout(debounceId);
            resolve(matched);
          };

          const observer = new MutationObserver(() => {
            if (isStale()) {
              finish(false);
              return;
            }
            window.clearTimeout(debounceId);
            debounceId = window.setTimeout(async () => {
              if (finished || isStale()) {
                finish(false);
                return;
              }
              if (await applyItemConfigurationToForm(container, item, isStale)) finish(true);
            }, 160);
          });
          observer.observe(bcpo, { childList: true, subtree: true });

          const timeoutId = window.setTimeout(async () => {
            if (finished) return;
            if (isStale()) {
              finish(false);
              return;
            }
            finish(await applyItemConfigurationToForm(container, item, isStale));
          }, Math.max(0, Math.min(4000, deadline - Date.now())));
        });
      };

      const isProductModalVisible = () => productModal?.getAttribute('aria-hidden') === 'false';

      // Park the rendered product node outside the document whenever the modal is closed.
      // Leaving it attached is what let a previous product's option swatches keep intercepting
      // clicks: `.modal` hides itself with inherited `visibility`/`pointer-events` plus
      // `opacity: 0`, and the VO/BCPO stylesheet re-declares `visibility: visible;
      // pointer-events: auto` on its swatch labels — so they stayed hit-testable, invisibly,
      // over the page behind. Detaching is the one guarantee no third-party stylesheet can
      // override. The node itself lives on in state.modalCache, keeping its rendered options and
      // selections for the next open exactly as before.
      const detachProductModalContent = () => {
        if (!productModalInner || isProductModalVisible()) return;
        if (!productModalInner.firstChild) return;
        setRestoringState(productModalInner, false);
        productModalInner.replaceChildren();
      };

      let detachContentTimer = 0;
      // CSS selector for the control that opened the product dialog, re-resolved on close.
      // A live selector rather than the element itself: the quote list re-renders while the
      // dialog is open, so the original node is usually gone by the time focus comes back.
      let modalReturnSelector = '';
      let modalWasOpen = false;

      // Focus has to leave the dialog for a real control, not stay on a container that is about
      // to be hidden and inert. theme.js restores the opener when it still exists; this covers
      // the case where it does not, and the quote-page equivalents (the line's own Edit button,
      // or the product search) are the right destinations.
      //
      // "Nothing holds focus" takes more shapes than `document.body`, and testing for that one
      // alone is why closing with Escape used to leave the shopper with no focus at all:
      // blurring the last focused node parks focus on `<html>` in iOS Safari rather than on
      // `<body>`, `activeElement` can read null while the dialog is being torn down, and
      // theme.js hands focus back to whatever opened the modal — here the visually-hidden proxy
      // button, `tabindex="-1"` and off-screen, so a keyboard user lands somewhere they cannot
      // see and cannot move on from. All four mean the same thing: restore the real opener.
      const isStrandedFocus = (active) =>
        !active ||
        active === document.body ||
        active === document.documentElement ||
        active === productModalOpenButton ||
        Boolean(productModal?.contains(active));

      const canTakeFocus = (node) =>
        Boolean(node) &&
        typeof node.focus === 'function' &&
        !node.disabled &&
        node.getClientRects().length > 0;

      const restoreFocusAfterModal = () => {
        if (!isStrandedFocus(document.activeElement)) return;
        // Visualizer adds stay in that list: do not send focus (or the viewport) to search.
        const visualizerFallback = state.fromVisualizerList
          ? query('[data-visualizer-product]') ||
            query('[data-visualizer-results] [data-edit-configuration]')
          : null;
        const target = [
          modalReturnSelector ? query(modalReturnSelector) : null,
          visualizerFallback,
          state.restoreSearchFocus ? query('[data-product-search]') : null,
          state.fromVisualizerList ? null : query('[data-focus-search]'),
        ].find(canTakeFocus);
        target?.focus({ preventScroll: true });
      };

      // `inert` takes the whole subtree out of hit-testing, focus order and the accessibility
      // tree at the browser level, where CSS from the options app cannot reach it. Driven off
      // `aria-hidden` rather than our own close helper so it covers every close path theme.js
      // owns too — the X button, Escape, and a click outside the dialog.
      const syncProductModalInertness = () => {
        if (!productModal) return;
        const open = isProductModalVisible();
        productModal.toggleAttribute('inert', !open);
        window.clearTimeout(detachContentTimer);
        const wasOpen = modalWasOpen;
        modalWasOpen = open;
        if (open) return;
        // Runs on every close path, and before `inert` can strand focus inside the dialog.
        if (wasOpen) restoreFocusAfterModal();
        // Every close lands here -- including theme.js's own close button, which never calls
        // closeProductModal -- so this is the one place guaranteed to clear the replay cover.
        // Leaving it set would clip and blank the next product opened into this dialog.
        productModal.classList.remove('is-replaying');
        if (wasOpen) {
          state.productModalOpen = false;
          if (state.visualizerNeedsRender) renderVisualizerList();
        }
        // Let the close transition finish before emptying the dialog, so the content does not
        // vanish mid-fade. `modal:closed` normally beats this; it is the fallback for when no
        // transition runs and that event never fires.
        detachContentTimer = window.setTimeout(detachProductModalContent, 500);
      };

      if (productModal && typeof MutationObserver === 'function') {
        new MutationObserver(syncProductModalInertness).observe(productModal, {
          attributes: true,
          attributeFilter: ['aria-hidden'],
        });
      }
      syncProductModalInertness();

      // After a failed restore, a shopper setting an option by hand is choosing the
      // configuration themselves, so saving is no longer a silent overwrite. Only real input
      // counts: the replay drives the same controls with synthetic clicks (`isTrusted: false`).
      // Capture phase, as the options widget stops propagation on some of its controls.
      const releaseRestoreBlockOnShopperInput = (event) => {
        if (!state.restoreBlocked || !event.isTrusted) return;
        const target = event.target instanceof Element ? event.target : null;
        if (!target?.closest('#bcpo, .bcpo-quickview')) return;
        if (!target.closest('input, select, label')) return;
        const quoteRoot = productModalInner.querySelector('[data-apq-quote-product]') || productModalInner;
        if (!customOptionsHydrated(quoteRoot)) return;
        state.restoreBlocked = false;
        setRestoringState(productModalInner, false);
      };
      productModalInner?.addEventListener('change', releaseRestoreBlockOnShopperInput, true);
      productModalInner?.addEventListener('click', releaseRestoreBlockOnShopperInput, true);

      // The theme re-enables the submit button on every variant change (main-product.js), so
      // picking the other drawer re-armed Save while the block still stood. Put it back.
      if (productModalInner && typeof MutationObserver === 'function') {
        new MutationObserver((records) => {
          if (!state.restoreBlocked) return;
          records.forEach(({ target }) => {
            if (target.matches?.('[data-action="add-to-cart"]') && !target.disabled) target.disabled = true;
          });
        }).observe(productModalInner, { attributes: true, attributeFilter: ['disabled'], subtree: true });
      }

      // theme.js's trap is a `focusin` bounce-back to whichever element was first focusable when
      // the modal opened; it never cycles. Tabbing past the last control in the dialog therefore
      // relies on the document seeing the focus move and shoving it back, which does not happen
      // when the browser hands focus to its own chrome, and leaves focus on the page behind the
      // dialog — invisible on mobile, where the dialog covers the viewport. Cycle Tab within the
      // dialog ourselves. Capture phase: the third-party options widget binds its own key
      // handlers on the controls it renders inside here, and some of them stop propagation.
      const MODAL_FOCUSABLE_SELECTOR = [
        'a[href]',
        'area[href]',
        'button:not([disabled])',
        'input:not([disabled]):not([type="hidden"])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'iframe',
        'audio[controls]',
        'video[controls]',
        '[contenteditable]:not([contenteditable="false"])',
        '[tabindex]:not([tabindex="-1"])',
      ].join(', ');

      // Recomputed on every Tab rather than cached: the dialog's contents are replaced wholesale
      // between opens, and the options widget shows and hides conditional fields as the shopper
      // configures the product.
      const dialogFocusables = () => {
        const dialog = productModal?.querySelector('.modal__dialog');
        if (!dialog) return [];
        return Array.from(dialog.querySelectorAll(MODAL_FOCUSABLE_SELECTOR)).filter(
          (node) =>
            !node.closest('[hidden], [inert], [aria-hidden="true"]') && node.getClientRects().length > 0
        );
      };

      productModal?.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'Tab' || event.altKey || event.ctrlKey || event.metaKey) return;
          if (!isProductModalVisible()) return;

          const focusables = dialogFocusables();
          if (focusables.length === 0) {
            // Nothing to move to — holding focus where it is beats letting it fall out of a
            // dialog the shopper cannot see past.
            event.preventDefault();
            return;
          }

          const first = focusables[0];
          const last = focusables[focusables.length - 1];
          const index = focusables.indexOf(document.activeElement);

          if (index === -1) {
            event.preventDefault();
            (event.shiftKey ? last : first).focus();
          } else if (event.shiftKey && index === 0) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && index === focusables.length - 1) {
            event.preventDefault();
            first.focus();
          }
        },
        true
      );

      // Backstop for focus moves the Tab handler never sees, because they do not start inside
      // the dialog: a script elsewhere on the page calling focus(), or a pointer press on the
      // content behind. theme.js aims its own bounce-back at an element captured at open time,
      // which for this dialog is a node from a previous product that has since been swapped out.
      document.addEventListener('focusin', (event) => {
        if (!isProductModalVisible() || !productModal) return;
        const target = event.target;
        if (!(target instanceof Element) || productModal.contains(target)) return;
        // The options widget opens its own "view larger images" dialog outside this one. It is
        // legitimately on top of us, so let it keep the focus it just took.
        if (target.closest('dialog[open], [role="dialog"], .modal[aria-hidden="false"]')) return;
        dialogFocusables()[0]?.focus({ preventScroll: true });
      });

      // theme.js pushes the modal onto a shared queue on every `open-modal` click, so clicking
      // the trigger for an already-open modal leaves a duplicate entry behind. The next close
      // pops the stale copy, its `transitionend` never fires, and `modal:closed` is never
      // dispatched — which left the section believing the modal was still open and still
      // editing a line. Only ever open when it is genuinely closed.
      const showProductModal = () => {
        if (isProductModalVisible()) return;
        // Clear inertness up front: the observer would only catch up a microtask after theme.js
        // flips `aria-hidden`, and the modal must be interactive the moment it is shown.
        productModal?.removeAttribute('inert');
        window.clearTimeout(detachContentTimer);
        productModalOpenButton?.click();
        // theme.js sets `aria-hidden` synchronously, so this now sees whether the open actually
        // happened. If it did not, put the guard straight back rather than leaving a closed but
        // interactive modal behind — the state the eager removal above would otherwise strand.
        syncProductModalInertness();
      };

      // The pristine (as-rendered) configuration of each cached product node, so reopening a
      // product for a plain add starts from its defaults instead of inheriting whatever the
      // last edit left selected.
      const pristineConfigurations = new WeakMap();

      // `readinessItem` is the line about to be replayed, when there is one: waiting on a field
      // it actually names is both the right readiness signal and the one the replay needs next,
      // so the snapshot costs the edit path no extra time. Without one, cap the wait short —
      // a product with no VO options would otherwise poll for the full timeout for nothing.
      const capturePristineConfiguration = async (container, isStale = neverStale, readinessItem = null) => {
        const quoteRoot = container?.querySelector('[data-apq-quote-product]') || container;
        if (!quoteRoot || pristineConfigurations.has(quoteRoot)) return;

        const ready = await waitForBcpoReady(container, readinessItem, readinessItem ? 8000 : 3000, isStale);
        // The widget paints its groups over a few frames; let them land before snapshotting.
        if (ready) await wait(200);
        if (isStale() || pristineConfigurations.has(quoteRoot)) return;

        const form = quoteRoot.querySelector('form[action*="/cart/add"]');
        pristineConfigurations.set(quoteRoot, {
          variant_id: form?.querySelector('select[name="id"], input[name="id"]')?.value || '',
          quantity: 1,
          properties: readModalProperties(container),
        });
      };

      const setRestoringState = (container, active) => {
        const quoteRoot = container?.querySelector('[data-apq-quote-product]') || container;
        quoteRoot?.classList.toggle('is-restoring', Boolean(active));
        container?.querySelectorAll('[data-action="add-to-cart"]').forEach((button) => {
          button.disabled = Boolean(active) || state.restoreBlocked;
          if (active) button.setAttribute('aria-busy', 'true');
          else button.removeAttribute('aria-busy');
        });
      };

      // Reopen the line from a fresh fetch. Dropping the cached node matters: if the widget
      // never painted the custom groups, reusing that node would fail the same way again.
      const retryModalOpen = () => {
        const last = state.lastModalOpen;
        if (!last) return;
        hideModalNotice();
        state.modalCache.delete(last.productUrl);
        openProductModal(last.button);
      };

      // Saving replaces the line's properties with whatever the editor holds
      // (RQ.updateItemFromForm), so after a failed restore it would silently drop the options
      // that did not come back -- and their surcharges with them. Keep Save blocked and offer
      // Retry. Once the custom groups are on screen the shopper may instead set them by hand,
      // which lifts the block (see the trusted-input listener on productModalInner); while the
      // groups are missing there is nothing to set them with, so Retry is the only way on.
      const showRestoreFailedNotice = (quoteRoot) => {
        showModalNotice(
          customOptionsHydrated(quoteRoot)
            ? 'We could not restore every saved option for this product. Retry, or choose the options below yourself before saving.'
            : 'We could not load this product’s options, so saving now would lose your saved configuration. Please retry.',
          { label: 'Retry', onClick: retryModalOpen }
        );
      };

      const beginRestoring = (container, message) => {
        state.restoringConfig = true;
        setRestoringState(container, true);
        showRestoringStatus(message);
      };

      const endRestoring = (container, token) => {
        setRestoringState(container, false);
        if (state.modalToken !== token) return;
        state.restoringConfig = false;
        hideRestoringStatus();
      };

      // Replay a saved (or pristine) configuration onto the already-visible modal. This runs
      // detached from the open path on purpose: the VO/BCPO widget can take seconds to settle
      // its dependent option groups, and a shopper should never wait on that before seeing the
      // product. Only the option widget is blocked meanwhile, via `is-restoring`.
      const restoreModalConfiguration = async (container, item, message, token, deadline = Infinity) => {
        const isSuperseded = () => state.modalToken !== token;
        // Every wait below polls this, so running out of time ends the whole replay at once
        // rather than each wait sitting out its own timeout in turn.
        const isStale = () => isSuperseded() || Date.now() >= deadline;
        const quoteRoot = container.querySelector('[data-apq-quote-product]') || container;

        applyVariantAndQuantity(container, item);
        if (configurationMatchesItem(container, item)) {
          endRestoring(container, token);
          updateModalPrice(quoteRoot);
          return true;
        }

        beginRestoring(container, message);

        let matched = false;
        try {
          matched = await applyItemConfigurationWithRetry(container, item, isStale, deadline);
        } catch (error) {
          matched = false;
        }

        if (!matched && state.editingLineKey && !isSuperseded()) state.restoreBlocked = true;
        endRestoring(container, token);
        if (isSuperseded()) return matched;

        updateModalPrice(quoteRoot);
        if (state.restoreBlocked) showRestoreFailedNotice(quoteRoot);
        return matched;
      };

      // Show the modal first, then reconcile its options. Deliberately not awaited by the
      // caller: the returned promise only exists so the open path can be tested/chained.
      // "Edit configuration" replays a saved configuration by driving the option widget's own
      // controls, so the shopper would otherwise watch swatches tick over one by one and the
      // panel reflow as each conditional group appears. Cover the modal while that runs and
      // reveal it once the replay has settled, so the first thing seen is the finished
      // configuration. Never leave a shopper staring at a spinner because a third-party widget
      // did not settle.
      //
      // One budget for the whole restore -- widget readiness, replay and its retry pass -- and
      // the cover comes down with it. These used to stack their own timeouts (8s ready, 6s per
      // branch, 2.5s per option, a 4s retry), so a product whose options never painted kept
      // the shopper on "Loading your saved options" for 25s and more.
      const restoreBudget = 10000;

      const finishModalOpen = (container, token) => {
        syncModalSubmitLabel(container);
        bindModalPriceUpdates(container);

        const quoteRoot = container.querySelector('[data-apq-quote-product]') || container;
        const isStale = () => state.modalToken !== token;

        const editingItem = state.editingLineKey
          ? state.editingItem ||
            (window.RQ?.getItems?.() || state.cart?.items || []).find((entry) => entry.key === state.editingLineKey)
          : null;

        // A plain add has nothing to replay that the shopper should not see, so it opens
        // straight onto the product exactly as before.
        const holdLoader = Boolean(editingItem);
        productModal.classList.remove('is-loading');
        productModal.classList.toggle('is-replaying', holdLoader);
        showProductModal();

        // Selecting an option focuses its input, and the browser scrolls that into view -- so a
        // replay drags the dialog down through its own content and takes the "loading your
        // saved options" row off screen with it (7,455px of content ends up scrolled to
        // 6,525px), leaving a blank panel. Hold the dialog at the top for as long as the cover
        // is up; the shopper is looking at a spinner, not at anything they could have scrolled.
        const dialog = productModal.querySelector('.modal__dialog');
        const pinDialogToTop = () => {
          if (dialog && dialog.scrollTop !== 0) dialog.scrollTop = 0;
        };

        let revealed = !holdLoader;
        let revealTimer = 0;
        const revealModal = () => {
          if (revealed) return;
          revealed = true;
          window.clearTimeout(revealTimer);
          dialog?.removeEventListener('scroll', pinDialogToTop);
          // A newer open owns the modal chrome by now; leave its cover state alone.
          if (state.modalToken !== token) return;
          productModal.classList.remove('is-replaying');
        };
        if (holdLoader) {
          pinDialogToTop();
          dialog?.addEventListener('scroll', pinDialogToTop);
          revealTimer = window.setTimeout(revealModal, restoreBudget);
        }

        const deadline = Date.now() + restoreBudget;
        const isOutOfTime = () => isStale() || Date.now() >= deadline;
        const hadPristine = pristineConfigurations.has(quoteRoot);
        // Waiting for the widget's first paint is itself part of the wait, so show the
        // indicator across the snapshot too rather than only once the replay starts.
        if (editingItem && !hadPristine) beginRestoring(container, labels.restoringSaved);

        return (async () => {
          try {
            // Snapshot the product's own defaults before anything is replayed onto this node,
            // so a later plain add can be put back to them instead of inheriting an edit.
            if (!hadPristine) {
              await capturePristineConfiguration(container, isOutOfTime, editingItem);
              if (isStale()) {
                setRestoringState(container, false);
                return false;
              }
            }

            if (editingItem) {
              return await restoreModalConfiguration(container, editingItem, labels.restoringSaved, token, deadline);
            }

            // A node rendered for the first time is already pristine — nothing to put back.
            const pristine = hadPristine ? pristineConfigurations.get(quoteRoot) : null;
            if (!pristine) return true;
            return await restoreModalConfiguration(container, pristine, labels.restoringOptions, token, deadline);
          } catch (error) {
            // Nothing awaits this, so a failed replay must not surface as an unhandled
            // rejection. The modal is already usable; the shopper just sets the options again.
            endRestoring(container, token);
            return false;
          } finally {
            revealModal();
          }
        })();
      };

      const prepareQuoteProductForm = (container) => {
        const quoteRoot = container.querySelector('[data-apq-quote-product]') || container;
        const form = quoteRoot.querySelector('form[action*="/cart/add"]');

        syncModalSubmitLabel(container);
        container.querySelectorAll('[data-action="add-to-cart"]').forEach((button) => {
          if (button.dataset.apqOriginalLabel == null) {
            button.dataset.apqOriginalLabel = button.textContent.trim() || labels.add;
          }
        });
        bindQuoteProductGallery(quoteRoot);

        if (!form || form.dataset.apqAjaxBound === 'true') {
          bindModalPriceUpdates(container);
          return;
        }
        form.dataset.apqAjaxBound = 'true';
        bindModalPriceUpdates(container);

        // Keep the shopper on the quote page; add to quote storage instead of the Shopify cart.
        const addToQuoteViaAjax = async (button) => {
          if (state.isAddingProduct) return;
          // A replay is still clicking through the option widget; saving now would store a
          // half-applied configuration.
          if (state.restoringConfig) {
            showModalNotice('Still loading this product’s options — one moment.');
            return;
          }
          // Theme and widget scripts re-enable this button on variant changes, so the disabled
          // state alone cannot be trusted to hold the block.
          if (state.restoreBlocked) {
            showRestoreFailedNotice(quoteRoot);
            return;
          }
          if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
            const invalidField = form.querySelector(':invalid');
            const groupLabel = invalidField
              ?.closest('.selector-wrapper')
              ?.querySelector('.bcpo-title')
              ?.textContent?.replace(/:\s*$/, '')
              .trim();
            showModalNotice(
              groupLabel
                ? `Choose an option for "${groupLabel}" before adding this to your quote.`
                : 'Choose the required options before adding this to your quote.'
            );
            return;
          }
          hideModalNotice();

          const submitButton =
            button || form.querySelector('[data-action="add-to-cart"]') || form.querySelector('[type="submit"]');
          const originalLabel = submitButton?.textContent;
          state.isAddingProduct = true;

          if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = labels.adding;
          }

          try {
            await waitForRQ();
            const meta = {
              product_id: quoteRoot.getAttribute('data-product-id'),
              handle: quoteRoot.getAttribute('data-product-handle'),
              product_title: quoteRoot.getAttribute('data-product-title'),
              url: quoteRoot.getAttribute('data-product-url'),
              image: quoteRoot.getAttribute('data-product-image'),
              source: 'quote-page',
            };
            const wasEditing = Boolean(state.editingLineKey);
            const editingKey = state.editingLineKey;
            if (wasEditing && editingKey) {
              await window.RQ.updateItemFromForm(editingKey, form, meta);
              state.editingLineKey = null;
              state.editingItem = null;
            } else {
              await window.RQ.addItemFromForm(form, meta);
            }
            window.RQ.markStarted(state.route || 'add');

            const quantity = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10) || 1;
            document.dispatchEvent(
              new CustomEvent('product:added', {
                bubbles: true,
                detail: { quantity, button: submitButton, wasEditing },
              })
            );
          } catch (error) {
            showNotice(error?.message || 'Could not add that product. Please try again.');
          } finally {
            state.isAddingProduct = false;
            if (submitButton) {
              submitButton.disabled = false;
              if (originalLabel) submitButton.textContent = originalLabel;
            }
          }
        };

        form.addEventListener(
          'submit',
          (event) => {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            addToQuoteViaAjax(event.submitter);
          },
          true
        );

        form.addEventListener(
          'click',
          (event) => {
            const button = event.target.closest('[data-action="add-to-cart"], [type="submit"]');
            if (!button || !form.contains(button) || button.disabled) return;
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            addToQuoteViaAjax(button);
          },
          true
        );
      };

      const enlargeImageUrl = (url) => {
        if (!url) return null;
        try {
          const path = url.split('?')[0];
          const parts = path.split('/');
          const encoded = parts[parts.length - 1];
          if (!encoded) return url;
          const decoded = JSON.parse(atob(encoded));
          if (!decoded?.edits?.resize) return url;
          decoded.edits.resize.width = Math.max(Number(decoded.edits.resize.width) || 200, 900);
          parts[parts.length - 1] = btoa(JSON.stringify(decoded));
          return parts.join('/');
        } catch (error) {
          return url;
        }
      };

      const isLikelyImageUrl = (url) => {
        if (!url || url.startsWith('#')) return false;
        try {
          const parsed = new URL(url, window.location.origin);
          return (
            /\.(jpe?g|png|gif|webp|svg|avif)(\?|$)/i.test(parsed.pathname) ||
            parsed.hostname.includes('cdn.shopify') ||
            parsed.hostname.includes('shopifycdn') ||
            parsed.pathname.includes('/files/') ||
            parsed.pathname.includes('/products/')
          );
        } catch (error) {
          return false;
        }
      };

      const variantPriceFromForm = (form, priceEl) => {
        const selected = form?.querySelector('select[name="id"] option:checked');
        const hidden = form?.querySelector('input[name="id"]');
        return Number(selected?.dataset?.price || hidden?.dataset?.price || priceEl?.dataset?.apqVariantPrice || 0);
      };

      const updateModalPrice = (root) => {
        if (!root) return;
        const quoteRoot = root.matches?.('[data-apq-quote-product]')
          ? root
          : root.querySelector('[data-apq-quote-product]') || root;
        const form = quoteRoot.querySelector('form[action*="/cart/add"]');
        const priceEl = quoteRoot.querySelector('[data-apq-modal-price]');
        if (!form || !priceEl || !window.RQ || typeof window.RQ.displayedFormPrice !== 'function') return;
        const variantPrice = variantPriceFromForm(form, priceEl);
        const next = window.RQ.displayedFormPrice(form, variantPrice, quoteRoot.dataset.productId);
        const formatted =
          typeof window.RQ.formatMoney === 'function' ? window.RQ.formatMoney(next.price) : money(next.price);
        if (priceEl.textContent !== formatted) priceEl.textContent = formatted;
        priceEl.dataset.apqVariantPrice = String(variantPrice);
      };

      const bindModalPriceUpdates = (container) => {
        const quoteRoot = container?.querySelector('[data-apq-quote-product]') || container;
        const form = quoteRoot?.querySelector('form[action*="/cart/add"]');
        if (!quoteRoot || !form || form.dataset.apqPriceBound === 'true') {
          updateModalPrice(quoteRoot);
          return;
        }
        form.dataset.apqPriceBound = 'true';
        const refresh = () => updateModalPrice(quoteRoot);
        form.addEventListener('change', refresh);
        form.addEventListener('input', refresh);
        form.addEventListener('click', (event) => {
          if (event.target.closest('#bcpo, .bcpo-quickview, [name="id"]')) {
            window.requestAnimationFrame(refresh);
          }
        });
        refresh();
        window.setTimeout(() => {
          const current = productModalInner?.querySelector('[data-apq-quote-product]');
          if (current?.dataset.productId === quoteRoot.dataset.productId) updateModalPrice(current);
        }, 300);
        window.setTimeout(() => {
          const current = productModalInner?.querySelector('[data-apq-quote-product]');
          if (current?.dataset.productId === quoteRoot.dataset.productId) updateModalPrice(current);
        }, 1000);
      };

      const bindQuoteProductGallery = (root) => {
        if (!root || root.dataset.apqGalleryBound === 'true') return;
        root.dataset.apqGalleryBound = 'true';

        const stageImage = root.querySelector('[data-apq-stage-image]');
        if (!stageImage) return;

        const setStageImage = (url, alt) => {
          const nextUrl = enlargeImageUrl(url) || url;
          if (!nextUrl) return;
          stageImage.src = nextUrl;
          stageImage.removeAttribute('srcset');
          if (alt) stageImage.alt = alt;
        };

        const syncThumbSelection = (activeThumb) => {
          root.querySelectorAll('[data-apq-thumb]').forEach((thumb) => {
            const selected = thumb === activeThumb;
            thumb.classList.toggle('is-selected', selected);
            thumb.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
        };

        const neutralizeVoImageLinks = () => {
          root.querySelectorAll('#bcpo a[href], .bcpo-quickview a[href]').forEach((link) => {
            const href = link.getAttribute('href') || '';
            if (!isLikelyImageUrl(href) && !isLikelyImageUrl(link.href)) return;
            if (!link.dataset.apqImageHref) {
              link.dataset.apqImageHref = href || link.href;
            }
            link.setAttribute('href', '#');
            link.removeAttribute('target');
            link.removeAttribute('download');
          });
        };

        // The VO/BCPO widget renders connector/finish choices as image swatches with no
        // visible name and no usable accessible name on the radio itself (each radio's own
        // "value" attribute already holds the full option text, just never surfaced). Add a
        // visible caption and an aria-label so sighted and screen-reader shoppers can both
        // tell the options apart.
        const labelVoImageOptions = () => {
          root
            .querySelectorAll('#bcpo .selector-wrapper.bcpo-images, .bcpo-quickview .selector-wrapper.bcpo-images')
            .forEach((wrapper) => {
              const groupLabel = wrapper.querySelector('.bcpo-title')?.textContent?.replace(/:\s*$/, '').trim() || '';
              wrapper.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((input) => {
                const optionName = (input.value || '').trim();
                if (!optionName) return;
                input.setAttribute('aria-label', groupLabel ? `${groupLabel}: ${optionName}` : optionName);

                const label =
                  wrapper.querySelector(`label[for="${input.id}"]`) ||
                  input.closest('.bcpo-image-parent')?.querySelector('label');
                if (!label) return;
                const image = label.querySelector('img');
                if (image && !image.alt) image.alt = optionName;

                // The image label is a fixed-size swatch, so the caption sits beside it as a
                // sibling. Make that caption a second <label for> and click the host padding
                // so the whole option card selects the radio, not just the picture.
                const captionHost = input.closest('.bcpo-image-parent') || label.parentElement;
                if (!captionHost) return;

                if (!input.id) {
                  input.id = `apq-vo-option-${sectionId}-${Math.random().toString(36).slice(2, 9)}`;
                  label.setAttribute('for', input.id);
                }

                let caption = captionHost.querySelector('[data-apq-option-caption]');
                if (!caption) {
                  caption = document.createElement('label');
                  caption.className = 'apq__vo-option-caption';
                  caption.dataset.apqOptionCaption = 'true';
                  caption.textContent = optionName;
                  captionHost.appendChild(caption);
                } else if (caption.tagName !== 'LABEL') {
                  const captionLabel = document.createElement('label');
                  captionLabel.className = caption.className;
                  captionLabel.dataset.apqOptionCaption = 'true';
                  captionLabel.textContent = caption.textContent || optionName;
                  caption.replaceWith(captionLabel);
                  caption = captionLabel;
                }
                caption.setAttribute('for', input.id);

                if (captionHost.dataset.apqOptionClickable !== 'true') {
                  captionHost.dataset.apqOptionClickable = 'true';
                  captionHost.addEventListener('click', (event) => {
                    if (input.disabled) return;
                    if (event.target.closest('input, label, button, a')) return;
                    input.click();
                  });
                }
              });
            });
        };

        const hideVoPriceNotes = () => {
          const pattern = /selection will add|will add .* to price|adds? .* to (the )?price/i;
          root.querySelectorAll('#bcpo *, .bcpo-quickview *').forEach((node) => {
            if (node.children.length > 0) return;
            const text = (node.textContent || '').trim();
            if (!text || !pattern.test(text)) return;
            const hideTarget = node.closest('p, span, div, small, em, strong, label') || node;
            hideTarget.setAttribute('data-apq-hide-price-note', 'true');
          });
        };

        neutralizeVoImageLinks();
        hideVoPriceNotes();
        labelVoImageOptions();

        // Observe `root` itself, not the #bcpo node: the VO/BCPO widget can replace that whole
        // element (not just mutate its children) while rendering, which would silently detach
        // an observer scoped to the original #bcpo reference and stop it from ever firing again.
        if (typeof MutationObserver === 'function') {
          const observer = new MutationObserver(() => {
            neutralizeVoImageLinks();
            hideVoPriceNotes();
            labelVoImageOptions();
            updateModalPrice(root);
          });
          observer.observe(root, { childList: true, subtree: true });
        }

        root.addEventListener(
          'click',
          (event) => {
            const thumb = event.target.closest('[data-apq-thumb]');
            if (thumb && root.contains(thumb)) {
              event.preventDefault();
              setStageImage(thumb.dataset.imageUrl, thumb.dataset.imageAlt);
              syncThumbSelection(thumb);
              return;
            }

            // Keep VO option selection working, but never navigate to option image URLs
            // and never swap the main gallery image from option clicks.
            const bcpoHit = event.target.closest('#bcpo a, .bcpo-quickview a');
            if (!bcpoHit || !root.contains(bcpoHit)) return;

            const href = bcpoHit.dataset.apqImageHref || bcpoHit.getAttribute('href') || '';
            if (href === '#' || isLikelyImageUrl(href) || isLikelyImageUrl(bcpoHit.href)) {
              event.preventDefault();
            }
          },
          true
        );
      };

      const closeProductModal = () => {
        state.productModalOpen = false;
        state.isAddingProduct = false;
        state.editingLineKey = null;
        state.editingItem = null;
        state.restoreBlocked = false;
        // Retire the token so a replay still walking the option widget stops touching it.
        state.modalToken += 1;
        state.restoringConfig = false;
        hideRestoringStatus();
        setRestoringState(productModalInner, false);
        if (productModal?.getAttribute('aria-hidden') === 'false') {
          document.dispatchEvent(new CustomEvent('modal:close'));
        }
        productModal?.classList.remove('is-loading');
        productModal?.classList.remove('is-replaying');
        // Re-assert the guard directly: when the modal was already hidden nothing above changed
        // `aria-hidden`, so the observer never runs.
        syncProductModalInertness();
        // The rendered markup (and the third-party option widget it holds) stays in
        // state.modalCache, so reopening the same product reuses the already-initialised options
        // instead of depending on a script that only renders once per page load. It is detached
        // from the document once the close transition has run — see detachProductModalContent.
        if (state.visualizerNeedsRender) renderVisualizerList();
      };

      const openProductModal = async (button) => {
        const handle = button.dataset.productHandle;
        const productUrl = handle
          ? `${routesRoot}products/${encodeURIComponent(handle)}?view=apq-quote`
          : button.dataset.productUrl || '';
        if (!productUrl || state.isAddingProduct) return;

        const isEdit = Boolean(button.dataset.editConfiguration);
        state.fromVisualizerList = Boolean(button.dataset.visualizerProduct) && !isEdit;
        // A plain add needs a return target as much as an edit does: closing with Escape has to
        // put focus back on the search result that opened the dialog, not drop it on the page.
        if (isEdit && button.dataset.lineKey) {
          modalReturnSelector = `[data-edit-configuration][data-line-key="${CSS.escape(button.dataset.lineKey)}"]`;
        } else if (!isEdit && button.dataset.visualizerProduct && button.dataset.productHandle) {
          modalReturnSelector = `[data-visualizer-product][data-product-handle="${CSS.escape(button.dataset.productHandle)}"]`;
        } else if (!isEdit && button.dataset.productHandle) {
          modalReturnSelector = `[data-add-product][data-product-handle="${CSS.escape(button.dataset.productHandle)}"]`;
        } else {
          modalReturnSelector = '';
        }
        const editingItem = isEdit
          ? (window.RQ?.getItems?.() || state.cart?.items || []).find((entry) => entry.key === button.dataset.lineKey)
          : null;
        state.editingLineKey = editingItem?.key || (isEdit ? button.dataset.lineKey || null : null);
        state.editingItem = editingItem || null;

        // Invalidate any still-in-flight fetch/render from a previously opened product so a
        // slow response can't land after the user has already moved on to a different one.
        const token = ++state.modalToken;
        state.restoreBlocked = false;
        state.lastModalOpen = { button, productUrl };
        hideModalNotice();

        const originalLabel = button.textContent;
        button.disabled = true;
        if (isEdit) {
          button.setAttribute('aria-busy', 'true');
        } else {
          button.textContent = labels.adding;
        }
        state.isAddingProduct = true;
        state.productModalOpen = true;

        const releaseButton = () => {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          if (!isEdit) button.textContent = originalLabel;
        };

        const cached = state.modalCache.get(productUrl);
        const cachedReady =
          Boolean(cached?.querySelector?.('.bcpo-front-button-option, .bcpo-front-image-option, [name^="properties"]')) &&
          customOptionsHydrated(cached);
        if (cached && cachedReady) {
          restoreBcpoGlobals(cached);
          productModalInner.replaceChildren(cached);
          prepareQuoteProductForm(productModalInner);
          // Show the cached product straight away and reconcile its options behind it, so
          // "Edit configuration" is instant instead of waiting on the VO widget to settle.
          state.isAddingProduct = false;
          releaseButton();
          finishModalOpen(productModalInner, token);
          return;
        }

        productModal.classList.add('is-loading');
        productModalInner.replaceChildren();
        showProductModal();

        try {
          const response = await fetch(productUrl, {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });
          if (!response.ok) throw new Error('Product request failed');
          const html = await response.text();
          if (state.modalToken !== token) return;

          // Keep the BCPO library on window.bcpo (it needs cart2/$ to render), but drop the
          // per-product "already ran" flags so a second open can paint into a fresh #bcpo.
          clearBcpoProductState();

          // Bootstrap VO globals before the form mounts.
          extractAndRunScripts(html);
          if (state.modalToken !== token) return;

          const quoteProduct = extractQuoteProduct(html);
          if (!quoteProduct) throw new Error('Quote product view unavailable');

          productModalInner.replaceChildren(quoteProduct);
          prepareQuoteProductForm(productModalInner);
          state.modalCache.set(productUrl, quoteProduct);

          const quoteRoot = productModalInner.querySelector('[data-apq-quote-product]') || productModalInner;
          rememberBcpoGlobals(quoteProduct);
          // VO uses jQuery `:hidden` (offset-based). Init while `.modal.is-loading` keeps
          // `.modal__inner` at `display: none` and the widget paints an empty #bcpo.
          productModal.classList.remove('is-loading');
          showProductModal();
          await wait(50);
          if (state.modalToken !== token) return;
          reinitalizeVoOptions(quoteRoot);
          finishModalOpen(productModalInner, token);
        } catch (error) {
          if (state.modalToken !== token) return;
          closeProductModal();
          productModalInner.replaceChildren();
          showNotice('We could not load that product. Please try again.');
        } finally {
          // Only clear the shared "in progress" flag if a newer open hasn't already claimed it
          // (e.g. the shopper closed this product before it finished loading and opened another).
          if (state.modalToken === token) state.isAddingProduct = false;
          releaseButton();
        }
      };

      const focusProductSearch = () => {
        const addPanel = query('[data-panel="add"]');
        const searchBlock = query('.apq__search-block', addPanel);
        const searchInput = query('[data-product-search]');
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (searchBlock) {
          searchBlock.scrollIntoView({
            behavior: prefersReducedMotion ? 'auto' : 'smooth',
            block: 'center',
          });
        }

        window.requestAnimationFrame(() => {
          searchInput?.focus({ preventScroll: true });
        });
      };

      const clearProductSearch = () => {
        window.clearTimeout(state.searchTimer);
        state.searchTimer = null;
        if (state.searchController) {
          state.searchController.abort();
          state.searchController = null;
        }

        const searchInput = query('[data-product-search]');
        const status = query('[data-search-status]');
        const results = query('[data-search-results]');

        if (searchInput) searchInput.value = '';
        if (status) status.textContent = '';
        if (results) results.replaceChildren();
      };

      const handleProductAddedToQuote = async (detail = {}) => {
        if (!state.productModalOpen) return;
        state.restoreSearchFocus = !state.fromVisualizerList;
        try {
          await waitForRQ();
          applyQuoteToState({ preserveSelection: true });
          closeProductModal();
          showNotice(detail.wasEditing ? labels.updated : labels.added);
        } catch (error) {
          closeProductModal();
          showNotice(
            detail.wasEditing
              ? 'Configuration updated, but we could not refresh the list. Use Refresh products.'
              : 'Product added, but we could not refresh the list. Use Refresh products.'
          );
        } finally {
          clearProductSearch();
        }
      };

      const searchProducts = async (term) => {
        const status = query('[data-search-status]');
        const results = query('[data-search-results]');
        if (state.searchController) state.searchController.abort();
        if (term.trim().length < 2) {
          status.textContent = '';
          results.replaceChildren();
          return;
        }
        state.searchController = new AbortController();
        const requestedTerm = term.trim();
        status.textContent = 'Searching…';
        try {
          const params = new URLSearchParams({
            q: requestedTerm,
            'resources[type]': 'product',
            'resources[limit]': '6',
            'resources[options][unavailable_products]': 'last',
            'resources[options][fields]': 'title,product_type,variants.title,vendor,variants.sku',
          });
          const response = await fetch(`${routesRoot}search/suggest.json?${params.toString()}`, {
            headers: { Accept: 'application/json' },
            signal: state.searchController.signal,
            credentials: 'same-origin',
          });
          if (!response.ok) throw new Error('Search failed');
          const data = await response.json();
          if (query('[data-product-search]').value.trim() !== requestedTerm) return;
          const products = data.resources?.results?.products || [];
          renderSearchResults(products);
        } catch (error) {
          if (error.name === 'AbortError') return;
          results.replaceChildren();
          status.textContent =
            'Search is unavailable right now. Browse the catalogue and return here after adding products.';
        }
      };

      const cartSwitchConfirm = query('[data-cart-switch-confirm]');

      const hideCartSwitchConfirm = () => {
        if (cartSwitchConfirm) cartSwitchConfirm.hidden = true;
      };

      const showCartSwitchConfirm = () => {
        if (!cartSwitchConfirm) return;
        cartSwitchConfirm.hidden = false;
        cartSwitchConfirm.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };

      // Starting from the cart replaces the whole quote item list (see RQ.importCart). If the
      // shopper already has quote items that didn't come from the cart, switching routes here
      // would silently destroy that work, so confirm first instead of clobbering it.
      const hasNonCartQuoteItems = () => {
        if (!window.RQ || typeof window.RQ.getItems !== 'function') return false;
        return window.RQ.getItems().some((item) => item.source !== 'cart');
      };

      queryAll('[data-route]').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.dataset.route === 'cart') {
            importCartExplicitly();
            return;
          }
          startRoute(button.dataset.route);
        });
      });

      query('[data-cart-switch-cancel]')?.addEventListener('click', hideCartSwitchConfirm);
      query('[data-cart-switch-confirm-yes]')?.addEventListener('click', () => {
        hideCartSwitchConfirm();
        startRoute('cart', { explicitImport: true });
      });

      // The one entry point cart import has, shared by the "Use my cart" card, the empty-quote
      // "Use my cart again" button and the cart page/drawer CTA (which arrives as `?rq_import=1`).
      // Quote-only work is never replaced without asking first.
      const importCartExplicitly = (options = {}) => {
        if (hasNonCartQuoteItems()) {
          showStart();
          showCartSwitchConfirm();
          return;
        }
        startRoute('cart', { explicitImport: true, ...options });
      };

      queryAll('[data-reimport-cart]').forEach((button) => {
        button.addEventListener('click', () => importCartExplicitly());
      });

      query('[data-upload-use-cart]')?.addEventListener('click', async (event) => {
        const button = event.currentTarget;
        if (!(button instanceof HTMLButtonElement) || button.disabled) return;
        button.disabled = true;
        try {
          const response = await fetch(`${routesRoot}cart.js`, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
          });
          const cart = response.ok ? await response.json() : null;
          const count = Number(cart?.item_count) || 0;
          const handoff = query('[data-upload-cart-handoff]');
          if (handoff && response.ok) handoff.hidden = count < 1;
          if (response.ok && count < 1) return;
          importCartExplicitly();
        } catch (error) {
          importCartExplicitly();
        } finally {
          button.disabled = false;
        }
      });

      queryAll('[data-switch-route]').forEach((button) => {
        button.addEventListener('click', () => startRoute(button.dataset.switchRoute));
      });

      queryAll('[data-back-start]').forEach((button) => button.addEventListener('click', showStart));

      queryAll('[data-refresh-cart]').forEach((button) => {
        button.addEventListener('click', async () => {
          if (button.disabled) return;
          const originalLabel = button.textContent;
          button.disabled = true;
          button.textContent = 'Refreshing…';
          try {
            // Refresh re-prices and re-checks what is in the quote. It deliberately does not
            // re-import the cart: that would resurrect lines the shopper removed here.
            await refreshQuote({
              preserveSelection: true,
              reconcileCatalog: true,
            });
          } finally {
            button.disabled = false;
            button.textContent = originalLabel;
          }
        });
      });

      queryAll('[data-next="project"]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!validateStepOne()) return;
          state.reviewedSignature = isUploadRoute() ? '' : cartSignature();
          showPanel('project');
        });
      });

      query('[data-next="contact"]').addEventListener('click', () => {
        const projectPanel = query('[data-panel="project"]');
        if (!validateRequiredFields(projectPanel)) return;
        showPanel('contact');
      });

      queryAll('[data-back]').forEach((button) => {
        button.addEventListener('click', () => {
          const target = button.dataset.back === 'step-one' ? state.route : button.dataset.back;
          showPanel(target);
        });
      });

      queryAll('[data-summary-edit]').forEach((button) => {
        button.addEventListener('click', async () => {
          if (button.dataset.summaryEdit !== 'products') {
            showPanel('project');
            return;
          }
          if (isUploadRoute()) {
            showPanel(state.route);
            return;
          }
          // The quote store is shared across tabs, so pull the latest state (including any
          // addition made from another tab) before showing the products step, instead of
          // relying on whatever was last rendered into this tab's in-memory state.
          await refreshQuote({
            preserveSelection: true,
            silent: true,
            reconcileCatalog: true,
          });
          showPanel(state.route);
        });
      });

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-apq-qty-input]')) {
          const input = event.target;
          const nextQuantity = Number.parseInt(input.value, 10);
          if (!Number.isFinite(nextQuantity) || nextQuantity < 0) {
            input.value = input.dataset.currentValue || '1';
            return;
          }
          changeLineQuantity(input.dataset.lineKey, nextQuantity);
          return;
        }

        if (event.target.matches('[data-contact-phone]')) syncPreferredContact();

        const group = event.target.closest('[data-required-group]');
        if (group && query('input:checked', group)) clearGroupInvalid(group);
        if (event.target.matches('[data-package-product]')) syncProductsNeededField();

        updateSummary();
        saveDraft();
      });

      root.addEventListener('input', (event) => {
        if (event.target.matches('[data-apq-qty-input]')) return;
        if (event.target.matches('[data-contact-phone]')) syncPreferredContact();
        updateSummary();
        saveDraft();
      });

      const searchInput = query('[data-product-search]');
      searchInput.addEventListener('input', () => {
        window.clearTimeout(state.searchTimer);
        state.searchTimer = window.setTimeout(() => searchProducts(searchInput.value), 280);
      });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && event.target.matches('[data-apq-qty-input]')) {
          event.preventDefault();
          event.target.blur();
        }
      });

      root.addEventListener('click', (event) => {
        const quantityControl = event.target.closest('[data-apq-qty-change]');
        if (quantityControl) {
          event.preventDefault();
          changeLineQuantity(quantityControl.dataset.lineKey, quantityControl.dataset.apqQtyChange);
          return;
        }

        const removeVisualizer = event.target.closest('[data-remove-visualizer]');
        if (removeVisualizer) {
          event.preventDefault();
          if (!dropVisualizerHandle(removeVisualizer.dataset.removeVisualizer)) return;
          renderVisualizerList();
          return;
        }

        const addButton = event.target.closest('[data-add-product]');
        if (addButton) {
          event.preventDefault();
          openProductModal(addButton);
          return;
        }

        const editButton = event.target.closest('[data-edit-configuration]');
        if (editButton) {
          event.preventDefault();
          openProductModal(editButton);
          return;
        }

        const focusSearchButton = event.target.closest('[data-focus-search]');
        if (focusSearchButton) {
          event.preventDefault();
          focusProductSearch();
        }
      });

      document.addEventListener('product:added', (event) => {
        handleProductAddedToQuote(event.detail || {});
      });

      productModal?.addEventListener('modal:closed', () => {
        // `modal:closed` arrives on a CSS transition, so it can land after a new open has
        // already reopened the modal. Ignore it in that case or it would tear down the open
        // that is now on screen.
        if (isProductModalVisible()) return;
        state.productModalOpen = false;
        state.editingLineKey = null;
        state.editingItem = null;
        state.restoreBlocked = false;
        state.modalToken += 1;
        state.restoringConfig = false;
        hideRestoringStatus();
        setRestoringState(productModalInner, false);
        productModal.classList.remove('is-loading');
        detachProductModalContent();
        if (!state.restoreSearchFocus) return;
        state.restoreSearchFocus = false;
        query('[data-product-search]')?.focus();
      });

      form.addEventListener('submit', async (event) => {
        if (isUploadRoute()) {
          event.preventDefault();
          return;
        }
        if (state.isSubmitting) return;
        event.preventDefault();
        if (!validateContact()) return;
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        const submittedRoute = state.route;
        state.isSubmitting = true;
        query('[data-submit-quote]').disabled = true;
        const resetSubmitting = () => {
          state.isSubmitting = false;
          query('[data-submit-quote]').disabled = false;
          queryAll('[data-package-product]', form).forEach((field) => {
            field.disabled = false;
          });
        };

        const previousSignature = state.reviewedSignature;
        const refreshed = await refreshQuote({ preserveSelection: true, silent: true });
        if (!refreshed) {
          resetSubmitting();
          showNotice('We could not verify the current quote. Please refresh and try again.');
          return;
        }
        if (state.route !== submittedRoute || state.panel !== 'contact') {
          resetSubmitting();
          return;
        }
        if (previousSignature && previousSignature !== cartSignature()) {
          resetSubmitting();
          showPanel(state.route, { noScroll: true });
          showNotice(
            'Your quote changed since you reviewed it. Check the products and selected options before continuing.'
          );
          return;
        }
        if (!includedItems().length) {
          resetSubmitting();
          showPanel(state.route, { noScroll: true });
          showNotice('Add at least one product for the quote.');
          return;
        }

        if (!validateContact() || !form.checkValidity()) {
          resetSubmitting();
          form.reportValidity();
          return;
        }

        const reference = createReference();
        referenceField.value = reference;
        contactNameField.value = [
          query('[name="contact[First name]"]')?.value,
          query('[name="contact[Last name]"]')?.value,
        ]
          .filter(Boolean)
          .join(' ');
        productCountField.value = String(includedItems().length);
        quoteBodyField.value = buildQuoteBody();
        syncProductsNeededField();
        queryAll('[data-package-product]', form).forEach((field) => {
          field.disabled = true;
        });
        saveDraft();

        const submitNativeForm = () => form.requestSubmit();

        if (typeof window.trackFormLead === 'function') {
          window.trackFormLead();
        }

        if (typeof window.trackMetaLead === 'function') {
          window.trackMetaLead();
        }

        if (typeof window.trackGoogleAdsLead === 'function') {
          window.trackGoogleAdsLead(submitNativeForm);
        } else {
          submitNativeForm();
        }
      });

      const refreshOnReturn = () => {
        if ((state.route === 'cart' || state.route === 'add') && !document.hidden) {
          refreshQuote({ preserveSelection: true, silent: true });
        }
      };
      window.addEventListener('focus', refreshOnReturn);
      window.addEventListener('pageshow', refreshOnReturn);
      document.addEventListener('visibilitychange', refreshOnReturn);
      document.addEventListener('rq:change', () => {
        if (state.isUpdatingCart || state.isAddingProduct) return;
        if (state.route !== 'cart' && state.route !== 'add') return;
        applyQuoteToState({ preserveSelection: true });
      });

      const postedSuccessfully = root.dataset.postedSuccessfully === 'true';
      const quoteSent = urlHasQuoteSent();
      if (postedSuccessfully || quoteSent) {
        const draft = readDraft();
        const saved = readQuoteSuccessDetails() || {};
        let reference = saved.reference || 'AQ-RECEIVED';
        try {
          reference = saved.reference || sessionStorage.getItem(`${storageKey}-reference`) || reference;
        } catch (error) {
          // Use the fallback reference when storage is unavailable.
        }
        const email = quoteSent
          ? saved.email || readGloboEmail() || draft?.values?.['contact[email]'] || 'your email'
          : draft?.values?.['contact[email]'] || saved.email || 'your email';
        showSuccessScreen(email, reference);
        resetQuoteFlow();
        if (quoteSent) cleanQuoteSentParam();
        waitForRQ()
          .then(applyRqClear)
          .catch(() => {
            applyRqClear();
          });
        return;
      }

      const urlRoute = (() => {
        try {
          const route = new URLSearchParams(window.location.search).get('route');
          if (route === 'cart' || route === 'add' || route === 'build' || route === 'upload') {
            return route === 'upload' ? 'build' : route;
          }
        } catch (error) {
          // Ignore malformed URLs.
        }
        return '';
      })();

      // Set by the cart page / cart drawer CTA. It carries the shopper's explicit intent to
      // import, which a bare `?route=cart` must not imply — see startRoute.
      const urlImportCart = (() => {
        try {
          return new URLSearchParams(window.location.search).get('rq_import') === '1';
        } catch (error) {
          return false;
        }
      })();

      const urlQuoteReady = (() => {
        try {
          return new URLSearchParams(window.location.search).get('rq_ready') === '1';
        } catch (error) {
          return false;
        }
      })();

      const urlVisualizerHandles = (() => {
        try {
          return parseVisualizerHandles(new URLSearchParams(window.location.search).get('products'));
        } catch (error) {
          return [];
        }
      })();

      const storedVisualizer = readVisualizerRecord();
      if (urlVisualizerHandles.length) {
        state.visualizerHandles = urlVisualizerHandles;
        state.visualizerProducts = {};
        persistVisualizerRecord();
      } else if (storedVisualizer.handles.length) {
        state.visualizerHandles = storedVisualizer.handles;
        state.visualizerProducts = storedVisualizer.products;
      }

      const draft = readDraft();
      if (draft?.values) restoreValues(draft.values);
      syncProductsNeededField();
      syncPreferredContact();
      if (Array.isArray(draft?.includedKeys)) {
        state.includedKeys = new Set(draft.includedKeys);
        state.hasInclusionSelection = true;
      }
      if (draft?.reviewedSignature) state.reviewedSignature = draft.reviewedSignature;
      const cleanRouteParam = () => {
        try {
          const cleanUrl = new URL(window.location.href);
          cleanUrl.searchParams.delete('route');
          cleanUrl.searchParams.delete('rq_import');
          cleanUrl.searchParams.delete('rq_ready');
          cleanUrl.searchParams.delete('products');
          window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
        } catch (error) {
          // Keep the query param if history API is unavailable.
        }
      };

      // A saved draft (this tab already had this route/step open) always wins over the
      // ?route= param: it carries the exact step to resume, not just which route to start.
      // The URL param decides where to start when there is no local draft, e.g. "Continue
      // Quote" clicked from a page that never opened this section before.
      // Visualizer products in the URL are an explicit handoff and always open Add products.
      const resumeRoute = urlVisualizerHandles.length
        ? 'add'
        : draft?.route && draft?.panel
        ? draft.route
        : urlRoute;

      const resumeToRoute = (route, panel) => {
        startRoute(route, { noScroll: true }).then(() => {
          if (state.route !== route) return;
          if (panel) showPanel(panel, { noScroll: true });
          if (urlRoute) cleanRouteParam();
        });
      };

      // The header trigger shows "manage" mode from RQ's own persisted state (items in
      // localStorage), independent of this tab's session draft. Without this fallback, landing
      // here with no draft and no ?route= (a bookmark, the nav link, a new tab) falls straight
      // to the start screen even though the header already reports an active quote — the header
      // and the page then visibly disagree about whether a quote exists. RQ's own script tag can
      // still be loading at this point, so this is the last resort and is awaited separately
      // rather than gating the fast, synchronous draft/urlRoute paths above.
      const resolveRqActiveRoute = async () => {
        try {
          await waitForRQ();
          const started = typeof window.RQ.isStarted === 'function' && window.RQ.isStarted();
          const hasItems = typeof window.RQ.getItemCount === 'function' && window.RQ.getItemCount() > 0;
          if (!started && !hasItems) return '';
          const route = typeof window.RQ.getRoute === 'function' ? window.RQ.getRoute() : 'add';
          return route === 'cart' || route === 'add' || route === 'build' || route === 'upload'
            ? route === 'upload'
              ? 'build'
              : route
            : 'add';
        } catch (error) {
          return '';
        }
      };

      if (urlQuoteReady && root.dataset.hasErrors !== 'true') {
        waitForRQ()
          .catch(() => null)
          .then(() => {
            startRoute('cart', { noScroll: true });
            cleanRouteParam();
          });
      } else if (urlImportCart && root.dataset.hasErrors !== 'true') {
        waitForRQ()
          .catch(() => null)
          .then(() => {
            importCartExplicitly({ noScroll: true });
            cleanRouteParam();
          });
      } else if (root.dataset.hasErrors === 'true') {
        state.route = draft?.route || 'add';
        updateStepOneLabel();
        routeField.value = routeLabel();
        syncRouteControls();
        showPanel(isUploadRoute() ? 'build' : 'contact', { noScroll: true });
      } else if (resumeRoute) {
        const resumePanel = urlVisualizerHandles.length
          ? 'add'
          : isUploadRoute(resumeRoute)
          ? 'build'
          : draft?.route === resumeRoute && draft?.panel
          ? draft.panel
          : resumeRoute === 'add' || resumeRoute === 'cart'
          ? resumeRoute
          : '';
        resumeToRoute(resumeRoute, resumePanel);
      } else {
        resolveRqActiveRoute().then((rqRoute) => {
          if (!rqRoute) {
            showStart();
            return;
          }
          resumeToRoute(rqRoute, rqRoute === 'add' || rqRoute === 'cart' ? rqRoute : '');
        });
      }

      bindGloboHost();
      watchGloboSubmission();
    });
  };

  initQuote(document);
  document.addEventListener('shopify:section:load', (event) => {
    initQuote(event.target);
  });
})();
